import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "food-category-manage" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { style: {"margin-bottom":"16px","display":"flex","justify-content":"space-between","align-items":"center"} }
const _hoisted_4 = { class: "favorite-selection-panel" }
const _hoisted_5 = {
  key: 0,
  class: "favorite-empty"
}
const _hoisted_6 = { class: "favorite-selection-title" }
const _hoisted_7 = { class: "favorite-food-names" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 6 }
const _hoisted_14 = { key: 7 }
const _hoisted_15 = { key: 8 }
const _hoisted_16 = { key: 9 }
const _hoisted_17 = { class: "pagination-container" }
const _hoisted_18 = { class: "form-row" }
const _hoisted_19 = { class: "form-row" }
const _hoisted_20 = { class: "form-row" }
const _hoisted_21 = { class: "form-row" }
const _hoisted_22 = { class: "dynamic-list spec-list" }
const _hoisted_23 = { class: "translation-lang-hint" }
const _hoisted_24 = { class: "dynamic-list" }
const _hoisted_25 = { class: "translation-lang-hint" }
const _hoisted_26 = { class: "cook-header" }
const _hoisted_27 = { class: "cook-values" }
const _hoisted_28 = { class: "form-row" }
const _hoisted_29 = { class: "form-row" }
const _hoisted_30 = { class: "form-row" }
const _hoisted_31 = { class: "form-row" }
const _hoisted_32 = { class: "form-row" }
const _hoisted_33 = { class: "dynamic-list" }
const _hoisted_34 = { class: "form-row" }
const _hoisted_35 = { class: "form-row" }
const _hoisted_36 = { class: "form-row" }
const _hoisted_37 = { class: "form-row" }
const _hoisted_38 = { class: "dynamic-list spec-list" }
const _hoisted_39 = { class: "translation-lang-hint" }
const _hoisted_40 = { class: "dynamic-list" }
const _hoisted_41 = { class: "translation-lang-hint" }
const _hoisted_42 = { class: "cook-header" }
const _hoisted_43 = { class: "cook-values" }
const _hoisted_44 = { class: "form-row" }
const _hoisted_45 = { class: "form-row" }
const _hoisted_46 = { class: "form-row" }
const _hoisted_47 = { class: "form-row" }
const _hoisted_48 = { class: "form-row" }

import { ref, reactive, onMounted, h, nextTick, computed } from 'vue';
  import { useRouter } from 'vue-router';
  import {
    SearchOutlined,
    ReloadOutlined,
    PlusOutlined,
    MinusOutlined,
    DeleteOutlined,
    AppstoreOutlined,
    TagsOutlined,
    PictureOutlined,
    ArrowLeftOutlined,
  } from '@ant-design/icons-vue';
  import { message, Modal } from 'ant-design-vue';
  import zhCN from 'ant-design-vue/es/locale/zh_CN';
  import dayjs, { type Dayjs } from 'dayjs';
  import {
    fetchCategoryItemList,
    fetchCategoryList,
    initializeFood,
    updateFood,
    forbidFood,
    fetchFoodDetail,
    fetchTagList,
    insertLanguageTranslation,
    updateLanguageTranslation,
    fetchLanguageTranslationList,
  } from '@/service/food';
  import { fetchShopKitchenList, fetchShopList } from '@/service/base';
  import ImageUploadWall from '@/components/ImageUploadWall.vue';
  import type { ImageItem } from '@/components/ImageUploadWall.vue';

  interface BatchFoodRecord {
    shopFoodId: number;
    shopFoodStatus: number;
    shopFoodName?: string;
  }
  interface FavoriteSelection {
    id: number;
    slot: number;
    foods: BatchFoodRecord[];
  }
  const SELECTED_SHOP_KEY = 'table_manage_selected_shop';
  const FAVORITE_SELECTIONS_KEY = 'food_manage_favorite_selections';

  // 新增菜品弹窗相关
  interface SpecItem {
    shopFoodSpecId?: number; // 新增时没有，编辑时有
    specName: string;
    languageTranslationId?: number;
    translationSpecName?: string;
    foodOutCode?: string;
    price: number;
    sourcePrice?: number;
    specStatus: number; // 0启用，1禁用
    sort: number; // 排序
  }

  // 附件项接口
  interface AttachmentItem {
    attachmentId?: number; // 新增时没有，编辑时有
    attachmentName: string;
    attachmentUrl: string;
    sort: number; // 排序
    attachmentStatus: number; // 0启用，1禁用
  }

  // 烹饪值接口
  interface CookValue {
    value: string;
    translationValue?: string;
  }

  // 烹饪项接口
  interface CookItem {
    cookId?: number; // 新增时没有，编辑时有
    cookName: string;
    languageTranslationId?: number;
    translationCookName?: string;
    cookType: 1 | 2; // 1多选，2单选
    valueList: CookValue[];
    cookStatus: number; // 0启用，1禁用
    sort: number; // 排序
  }

  interface FoodTranslationForm {
    languageTranslationId?: number;
    language: string;
    shopFoodName: string;
    shopFoodDesc: string;
    description: string;
    remark: string;
  }

  interface TranslationPayload {
    companyId: number;
    companyName: string;
    language: string;
    type: 5 | 6 | 7;
    entityId: number;
    entityName: string;
    translationJson: string;
    remark: string;
    languageTranslationId?: number;
  }

  interface LanguageTranslationRecord {
    languageTranslationId?: number;
    companyId?: number;
    companyName?: string;
    language?: string;
    type?: number;
    status?: number;
    entityId?: number;
    entityName?: string;
    translationJson?: string;
    remark?: string;
  }

  interface FoodTranslationJson {
    shopFoodName?: string;
    shopFoodDesc?: string;
    description?: string;
  }

  interface SpecTranslationJson {
    specName?: string;
  }

  interface CookTranslationJson {
    cookName?: string;
    cookValue?: Array<{ value?: string }>;
  }

  interface ShopKitchenOption {
    shopKitchenId?: number;
    shopId?: number;
    kitchenId?: number;
    kitchenName?: string;
  }

  interface FoodFormState {
    shopId?: number;
    kitchenId?: number;
    shopFoodCategoryId?: number;
    shopFoodName: string;
    shopFoodNameShort: string;
    shopFoodDesc: string;
    description: string;
    specList: SpecItem[];
    cookList: CookItem[];
    selectedTagNames: string[];
    translation: FoodTranslationForm;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'FoodManageView',
  setup(__props) {

  const outSortLabels: Record<number, string> = {
    100: '饮料',
    70: '冷菜',
    50: '热菜',
    20: '甜品',
  };

  // 表格列定义
  const columns = [
    {
      title: '菜品ID',
      dataIndex: 'shopFoodId',
      key: 'shopFoodId',
      width: 90,
    },
    {
      title: '菜品名称',
      dataIndex: 'shopFoodName',
      key: 'shopFoodName',
      width: 160,
    },
    {
      title: '菜品别名',
      dataIndex: 'shopFoodNameShort',
      key: 'shopFoodNameShort',
      width: 140,
    },
    {
      title: '当前状态',
      dataIndex: 'shopFoodStatus',
      key: 'shopFoodStatus',
      width: 100,
    },
    {
      title: '所属店铺',
      dataIndex: 'shopId',
      key: 'shopName',
      width: 150,
    },
    {
      title: '所属分类',
      dataIndex: 'shopFoodCategoryId',
      key: 'categoryName',
      width: 150,
    },
    {
      title: '标签',
      dataIndex: 'tags',
      key: 'tags',
      width: 180,
    },
    {
      title: '允许使用餐券',
      dataIndex: 'isFoodTicket',
      key: 'isFoodTicket',
      width: 130,
    },
    {
      title: '价格',
      dataIndex: 'price',
      key: 'price',
      width: 100,
    },
    {
      title: '库存',
      dataIndex: 'stockQuantity',
      key: 'stockQuantity',
      width: 90,
    },
    {
      title: '排序',
      dataIndex: 'sort',
      key: 'sort',
      width: 90,
    },
    {
      title: '制作时间（分钟）',
      dataIndex: 'cookTime',
      key: 'cookTime',
      width: 140,
    },
    {
      title: '出菜顺序',
      dataIndex: 'outSort',
      key: 'outSort',
      width: 100,
    },
    {
      title: '销量',
      dataIndex: 'salesCount',
      key: 'salesCount',
      width: 90,
    },
    {
      title: '菜品基础名称',
      dataIndex: 'foodName',
      key: 'foodName',
      width: 140,
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
      width: 180,
    },
    {
      title: '操作',
      key: 'action',
      width: 150,
      fixed: 'right',
    },
  ];

  // 响应式数据
  const loading = ref(false);
  const shopList = ref<any[]>([]);
  // 所有分类列表（用于名称映射）
  const categoryList = ref<any[]>([]);
  // 按店铺过滤后的分类选项（查询条件用）
  const searchCategoryOptions = ref<any[]>([]);
  // 按店铺过滤后的分类选项（新增弹窗用）
  const addCategoryOptions = ref<any[]>([]);
  // 按店铺过滤后的分类选项（编辑弹窗用）
  const editCategoryOptions = ref<any[]>([]);
  // 按店铺过滤后的标签选项（新增弹窗用）
  const addTagOptions = ref<any[]>([]);
  // 按店铺过滤后的标签选项（编辑弹窗用）
  const editTagOptions = ref<any[]>([]);
  // 按店铺过滤后的厨房选项（新增弹窗用）
  const addKitchenOptions = ref<ShopKitchenOption[]>([]);
  // 按店铺过滤后的厨房选项（编辑弹窗用）
  const editKitchenOptions = ref<ShopKitchenOption[]>([]);
  const kitchenOptionsByShopId = ref<Record<number, ShopKitchenOption[]>>({});
  const tableData = ref<any[]>([]);
  const total = ref(0);
  const dateRange = ref<[Dayjs, Dayjs] | null>(null);
  const selectedFoodIds = ref<number[]>([]);
  const selectedFoods = ref<BatchFoodRecord[]>([]);
  const batchTargetStatus = ref<0 | 1 | null>(null);
  const favoriteSelections = ref<FavoriteSelection[]>([]);
  const clearSelectedFoods = () => {
    selectedFoodIds.value = [];
    selectedFoods.value = [];
  };
  const rowSelection = computed(() => ({
    selectedRowKeys: selectedFoodIds.value,
    onChange: (selectedRowKeys: number[], selectedRows: BatchFoodRecord[]) => {
      selectedFoodIds.value = selectedRowKeys;
      selectedFoods.value = selectedRows;
    },
  }));
  const translationLanguageOptions = [
    { label: '英语', value: 'en' },
    { label: '法语', value: 'fr' },
  ];
  const addModalVisible = ref(false);
  const addSubmitting = ref(false);
  const addImageUploadWallRef = ref<InstanceType<typeof ImageUploadWall> | null>(null);

  // 编辑菜品弹窗相关
  const editModalVisible = ref(false);
  const editSubmitting = ref(false);
  const editImageUploadWallRef = ref<InstanceType<typeof ImageUploadWall> | null>(null);
  const editingFoodId = ref<number | undefined>(undefined);
  // 规格项接口
  const createEmptyTranslationForm = (): FoodTranslationForm => ({
    languageTranslationId: undefined,
    language: 'en',
    shopFoodName: '',
    shopFoodDesc: '',
    description: '',
    remark: '',
  });

  const addForm = reactive({
    shopId: undefined as number | undefined,
    shopFoodCategoryId: undefined as number | undefined,
    kitchenId: undefined as number | undefined,
    shopFoodName: '',
    shopFoodNameShort: '',
    shopFoodDesc: '',
    spec: '',
    price: undefined as number | undefined,
    bookAdvanceHour: 0,
    isFoodTicket: 0 as 0 | 1,
    description: '',
    stockQuantity: undefined as number | undefined,
    limitQuantity: undefined as number | undefined,
    sort: undefined as number | undefined,
    cookTime: undefined as number | undefined,
    outSort: undefined as number | undefined,
    imageList: [] as ImageItem[],
    specList: [] as SpecItem[],
    attachmentList: [] as AttachmentItem[],
    cookList: [] as CookItem[],
    selectedTagNames: [] as string[], // 选中的标签名称数组
    translation: createEmptyTranslationForm(),
  });

  // 编辑表单（复用 addForm 的结构，但需要单独管理）
  const editForm = reactive({
    shopId: undefined as number | undefined,
    shopFoodCategoryId: undefined as number | undefined,
    kitchenId: undefined as number | undefined,
    shopFoodName: '',
    shopFoodNameShort: '',
    shopFoodDesc: '',
    spec: '',
    price: undefined as number | undefined,
    bookAdvanceHour: 0,
    isFoodTicket: 0 as 0 | 1,
    description: '',
    stockQuantity: undefined as number | undefined,
    limitQuantity: undefined as number | undefined,
    sort: undefined as number | undefined,
    cookTime: undefined as number | undefined,
    outSort: undefined as number | undefined,
    shopFoodStatus: undefined as number | undefined,
    imageList: [] as ImageItem[],
    specList: [] as SpecItem[],
    attachmentList: [] as AttachmentItem[],
    cookList: [] as CookItem[],
    selectedTagNames: [] as string[], // 选中的标签名称数组
    translation: createEmptyTranslationForm(),
  });

  // 辅助函数：确保状态值始终是数字 0 或 1
  const ensureStatusValue = (value: any): number => {
    if (value === true || value === 1) return 1;
    if (value === false || value === 0) return 0;
    return 0; // 默认值
  };

  const resetTranslationForm = (translation: FoodTranslationForm) => {
    translation.languageTranslationId = undefined;
    translation.language = 'en';
    translation.shopFoodName = '';
    translation.shopFoodDesc = '';
    translation.description = '';
    translation.remark = '';
  };

  const clearFoodTranslationFields = (form: FoodFormState) => {
    form.translation.languageTranslationId = undefined;
    form.translation.shopFoodName = '';
    form.translation.shopFoodDesc = '';
    form.translation.description = '';
    form.translation.remark = '';
    form.specList.forEach((spec) => {
      spec.languageTranslationId = undefined;
      spec.translationSpecName = '';
    });
    form.cookList.forEach((cook) => {
      cook.languageTranslationId = undefined;
      cook.translationCookName = '';
      cook.valueList.forEach((value) => {
        value.translationValue = '';
      });
    });
  };

  const trimValue = (value?: string) => (value || '').trim();

  const hasTranslationValue = (values: Array<string | undefined>) =>
    values.some((value) => Boolean(trimValue(value)));

  const getTranslationLanguageLabel = (lang: string) =>
    translationLanguageOptions.find((item) => item.value === lang)?.label || lang;

  const addTranslationLanguageLabel = computed(() =>
    getTranslationLanguageLabel(addForm.translation.language),
  );
  const editTranslationLanguageLabel = computed(() =>
    getTranslationLanguageLabel(editForm.translation.language),
  );

  // 查询参数
  const queryParams = reactive({
    createtimeBegin: '',
    createtimeEnd: '',
    pageNum: 1,
    pageSize: 20,
    data: {
      shopId: undefined as number | undefined,
      shopFoodCategoryId: undefined as number | undefined,
      shopFoodName: '',
      shopFoodStatus: undefined as number | undefined,
      searchField: '',
    },
  });

  const persistFavoriteSelections = () => {
    try {
      localStorage.setItem(FAVORITE_SELECTIONS_KEY, JSON.stringify(favoriteSelections.value));
    } catch (error) {
      console.warn('保存菜品收藏方案失败:', error);
      message.warning('收藏方案保存失败，请检查浏览器存储空间');
    }
  };

  const isBatchFoodRecord = (value: unknown): value is BatchFoodRecord => {
    if (!value || typeof value !== 'object') return false;
    const record = value as Record<string, unknown>;
    return (
      typeof record.shopFoodId === 'number' &&
      (record.shopFoodStatus === 0 || record.shopFoodStatus === 1)
    );
  };

  const loadFavoriteSelections = () => {
    try {
      const storedValue = localStorage.getItem(FAVORITE_SELECTIONS_KEY);
      if (!storedValue) return;
      const parsedValue: unknown = JSON.parse(storedValue);
      if (!Array.isArray(parsedValue)) return;
      favoriteSelections.value = parsedValue
        .filter((item): item is Record<string, unknown> =>
          Boolean(item && typeof item === 'object'),
        )
        .map((item) => ({
          id: typeof item.id === 'number' ? item.id : Date.now(),
          slot: typeof item.slot === 'number' ? item.slot : 0,
          foods: Array.isArray(item.foods) ? item.foods.filter(isBatchFoodRecord) : [],
        }))
        .filter((item) => item.slot >= 1 && item.slot <= 3 && item.foods.length > 0)
        .slice(0, 3);
    } catch (error) {
      console.warn('读取菜品收藏方案失败:', error);
      favoriteSelections.value = [];
    }
  };

  const saveCurrentSelection = () => {
    if (selectedFoods.value.length === 0) {
      message.info('请先勾选需要收藏的菜品');
      return;
    }
    if (favoriteSelections.value.length >= 3) {
      message.warning('最多保存 3 个收藏方案，请先删除不需要的方案');
      return;
    }
    const usedSlots = new Set(favoriteSelections.value.map((item) => item.slot));
    const slot = [1, 2, 3].find((item) => !usedSlots.has(item));
    if (!slot) return;

    favoriteSelections.value.push({
      id: Date.now(),
      slot,
      foods: selectedFoods.value.map((food) => ({ ...food })),
    });
    favoriteSelections.value.sort((left, right) => left.slot - right.slot);
    persistFavoriteSelections();
    message.success(`收藏方案 ${slot} 保存成功`);
  };

  const removeFavoriteSelection = (favoriteId: number) => {
    favoriteSelections.value = favoriteSelections.value.filter((item) => item.id !== favoriteId);
    persistFavoriteSelections();
    message.success('收藏方案已删除');
  };

  const getFavoriteFoodNames = (favorite: FavoriteSelection) =>
    favorite.foods.map((food) => food.shopFoodName || `菜品 ${food.shopFoodId}`).join('、');

  const updateFavoriteFoodStatuses = (foodIds: number[], targetStatus: 0 | 1) => {
    if (foodIds.length === 0) return;
    const foodIdSet = new Set(foodIds);
    favoriteSelections.value.forEach((favorite) => {
      favorite.foods.forEach((food) => {
        if (foodIdSet.has(food.shopFoodId)) food.shopFoodStatus = targetStatus;
      });
    });
    persistFavoriteSelections();
  };

  const syncFavoriteFoodsFromList = (foods: BatchFoodRecord[]) => {
    const foodMap = new Map(foods.map((food) => [food.shopFoodId, food]));
    let changed = false;
    favoriteSelections.value.forEach((favorite) => {
      favorite.foods.forEach((food) => {
        const latestFood = foodMap.get(food.shopFoodId);
        if (!latestFood) return;
        if (
          food.shopFoodStatus !== latestFood.shopFoodStatus ||
          food.shopFoodName !== latestFood.shopFoodName
        ) {
          food.shopFoodStatus = latestFood.shopFoodStatus;
          food.shopFoodName = latestFood.shopFoodName;
          changed = true;
        }
      });
    });
    if (changed) persistFavoriteSelections();
  };

  const saveSelectedShop = (shopId: number | undefined) => {
    try {
      if (shopId) {
        localStorage.setItem(SELECTED_SHOP_KEY, String(shopId));
      } else {
        localStorage.removeItem(SELECTED_SHOP_KEY);
      }
    } catch (error) {
      console.warn('保存选中店铺失败:', error);
    }
  };

  const loadSelectedShop = () => {
    try {
      const savedShopId = localStorage.getItem(SELECTED_SHOP_KEY);
      return savedShopId ? Number(savedShopId) : undefined;
    } catch (error) {
      console.warn('读取选中店铺失败:', error);
      return undefined;
    }
  };

  const applySavedShopToQuery = async () => {
    const savedShopId = loadSelectedShop();
    const selected =
      shopList.value.find((shop) => Number(shop.shopId) === savedShopId) || shopList.value[0];
    queryParams.data.shopId = selected ? Number(selected.shopId) : undefined;
    if (!queryParams.data.shopId) return;
    saveSelectedShop(queryParams.data.shopId);
    queryParams.data.shopFoodCategoryId = undefined;
    await loadCategoryListByShop(queryParams.data.shopId, 'search');
  };

  // 格式化日期时间
  const formatDateTime = (dateStr: string | Date | undefined) => {
    if (!dateStr) return '-';
    return dayjs(dateStr).format('YYYY-MM-DD HH:mm:ss');
  };

  // 处理日期范围变化
  const handleDateRangeChange = (dates: [Dayjs, Dayjs] | null) => {
    if (dates && dates[0] && dates[1]) {
      // 开始时间：当天 00:00:00
      queryParams.createtimeBegin = dates[0].startOf('day').format('YYYY-MM-DD HH:mm:ss');
      // 结束时间：当天 23:59:59
      queryParams.createtimeEnd = dates[1].endOf('day').format('YYYY-MM-DD HH:mm:ss');
    } else {
      queryParams.createtimeBegin = '';
      queryParams.createtimeEnd = '';
    }
  };

  // 加载店铺列表
  const loadShopList = async () => {
    try {
      const response = await fetchShopList({
        pageNum: 1,
        pageSize: 999,
        data: { shopStatus: 0 },
      });
      if (response.code === 200) {
        shopList.value = response.result.list || [];
      }
    } catch (error) {
      console.error('加载店铺列表失败:', error);
      message.error('加载店铺列表失败');
    }
  };

  // 加载分类列表（用于名称映射，不用于联动下拉）
  const loadCategoryList = async () => {
    try {
      const response = await fetchCategoryList({
        pageNum: 1,
        pageSize: 999,
        data: { categoryStatus: 0 },
      });
      if (response.code === 200) {
        categoryList.value = response.result.list || [];
      }
    } catch (error) {
      console.error('加载分类列表失败:', error);
    }
  };

  // 根据店铺ID从后端查询分类列表（联动用）
  const loadCategoryListByShop = async (shopId: number, target: 'search' | 'add' | 'edit') => {
    try {
      const response = await fetchCategoryList({
        pageNum: 1,
        pageSize: 999,
        data: { categoryStatus: 0, shopId },
      });
      if (response.code === 200) {
        const list = response.result.list || [];
        if (target === 'search') {
          searchCategoryOptions.value = list;
        } else if (target === 'add') {
          addCategoryOptions.value = list;
        } else {
          editCategoryOptions.value = list;
        }
      } else {
        if (target === 'search') {
          searchCategoryOptions.value = [];
        } else if (target === 'add') {
          addCategoryOptions.value = [];
        } else {
          editCategoryOptions.value = [];
        }
      }
    } catch (error) {
      console.error('按店铺加载分类失败:', error);
      if (target === 'search') {
        searchCategoryOptions.value = [];
      } else if (target === 'add') {
        addCategoryOptions.value = [];
      } else {
        editCategoryOptions.value = [];
      }
    }
  };

  // 根据店铺ID从后端查询标签列表（联动用）
  const loadTagListByShop = async (shopId: number, target: 'add' | 'edit') => {
    try {
      const response = await fetchTagList({
        pageNum: 1,
        pageSize: 999,
        data: { tagStatus: 0, shopId },
      });
      if (response.code === 200) {
        // 将 API 返回的字段映射为界面使用的字段
        const list = (response.result.list || []).map((item: any) => ({
          ...item,
          shopFoodTagId: item.shopFoodTagId,
          tagName: item.tagName,
        }));
        if (target === 'add') {
          addTagOptions.value = list;
        } else {
          editTagOptions.value = list;
        }
      } else {
        if (target === 'add') {
          addTagOptions.value = [];
        } else {
          editTagOptions.value = [];
        }
      }
    } catch (error) {
      console.error('按店铺加载标签失败:', error);
      if (target === 'add') {
        addTagOptions.value = [];
      } else {
        editTagOptions.value = [];
      }
    }
  };

  const setKitchenOptions = (target: 'add' | 'edit', list: ShopKitchenOption[]) => {
    if (target === 'add') {
      addKitchenOptions.value = list;
    } else {
      editKitchenOptions.value = list;
    }
  };

  // 根据店铺ID从后端查询门店厨房列表（新增/编辑联动用）
  const loadKitchenListByShop = async (shopId: number, target: 'add' | 'edit') => {
    if (kitchenOptionsByShopId.value[shopId]) {
      setKitchenOptions(target, kitchenOptionsByShopId.value[shopId]);
      return kitchenOptionsByShopId.value[shopId];
    }

    try {
      const response = await fetchShopKitchenList({
        pageNum: 1,
        pageSize: 999,
        data: { shopId, status: 0 },
      });
      if (response.code === 200) {
        const list = (response.result.list || []) as ShopKitchenOption[];
        kitchenOptionsByShopId.value = {
          ...kitchenOptionsByShopId.value,
          [shopId]: list,
        };
        setKitchenOptions(target, list);
        return list;
      }
      setKitchenOptions(target, []);
      return [];
    } catch (error) {
      console.error('按店铺加载厨房失败:', error);
      setKitchenOptions(target, []);
      return [];
    }
  };

  const clearInvalidEditKitchenValue = () => {
    if (!editForm.kitchenId) return;
    const kitchenId = Number(editForm.kitchenId);
    if (editKitchenOptions.value.some((item) => Number(item.kitchenId) === kitchenId)) return;
    editForm.kitchenId = undefined;
  };

  // 加载菜品列表
  const loadFoodList = async () => {
    if (!queryParams.data.shopId) {
      tableData.value = [];
      total.value = 0;
      message.warning('请选择餐厅');
      return;
    }
    clearSelectedFoods();
    try {
      loading.value = true;

      // 构建查询参数，过滤掉空值
      const params: any = {
        pageNum: queryParams.pageNum,
        pageSize: queryParams.pageSize,
        data: {},
      };

      // 添加时间范围
      if (queryParams.createtimeBegin) {
        params.createtimeBegin = queryParams.createtimeBegin;
      }
      if (queryParams.createtimeEnd) {
        params.createtimeEnd = queryParams.createtimeEnd;
      }

      // 添加数据筛选条件（只添加有值的字段）
      if (queryParams.data.shopId !== undefined && queryParams.data.shopId !== null) {
        params.data.shopId = queryParams.data.shopId;
      }
      if (
        queryParams.data.shopFoodCategoryId !== undefined &&
        queryParams.data.shopFoodCategoryId !== null
      ) {
        params.data.shopFoodCategoryId = queryParams.data.shopFoodCategoryId;
      }
      if (queryParams.data.shopFoodName) {
        params.data.shopFoodName = queryParams.data.shopFoodName;
      }
      if (queryParams.data.searchField) {
        params.data.searchField = queryParams.data.searchField;
      }
      if (
        queryParams.data.shopFoodStatus !== undefined &&
        queryParams.data.shopFoodStatus !== null
      ) {
        params.data.shopFoodStatus = queryParams.data.shopFoodStatus;
      }

      const response = await fetchCategoryItemList(params);

      if (response.code === 200) {
        tableData.value = response.result.list || [];
        total.value = response.result.total || 0;
        syncFavoriteFoodsFromList(tableData.value);
      } else {
        message.error(response.msg || '查询失败');
        tableData.value = [];
        total.value = 0;
      }
    } catch (error) {
      console.error('加载分类列表失败:', error);
      message.error('加载菜品列表失败，请稍后重试');
      tableData.value = [];
      total.value = 0;
    } finally {
      loading.value = false;
    }
  };

  // 查询
  const handleSearch = () => {
    queryParams.pageNum = 1;
    loadFoodList();
  };

  // 查询条件中店铺切换时，联动分类（根据店铺ID重新查询分类）
  const handleShopChange = async (value: number | undefined) => {
    clearSelectedFoods();
    queryParams.data.shopId = value as any;
    queryParams.data.shopFoodCategoryId = undefined;
    saveSelectedShop(value);
    if (!value) {
      searchCategoryOptions.value = [];
      return;
    }
    await loadCategoryListByShop(Number(value), 'search');
  };

  // 打开新增菜品弹窗
  const openAddModal = () => {
    addForm.shopId = queryParams.data.shopId;
    addForm.shopFoodCategoryId = undefined;
    addForm.kitchenId = undefined;
    addForm.shopFoodName = '';
    addForm.shopFoodNameShort = '';
    addForm.shopFoodDesc = '';
    addForm.spec = '';
    addForm.price = undefined;
    addForm.bookAdvanceHour = 0;
    addForm.isFoodTicket = 0;
    addForm.description = '';
    addForm.stockQuantity = undefined;
    addForm.limitQuantity = undefined;
    addForm.sort = undefined;
    addForm.cookTime = undefined;
    addForm.outSort = undefined;
    addForm.imageList = [];
    addForm.specList = [];
    addForm.attachmentList = [];
    addForm.cookList = [];
    addForm.selectedTagNames = [];
    resetTranslationForm(addForm.translation);
    addModalVisible.value = true;
    if (addForm.shopId) {
      loadCategoryListByShop(Number(addForm.shopId), 'add');
      loadTagListByShop(Number(addForm.shopId), 'add');
      loadKitchenListByShop(Number(addForm.shopId), 'add');
    } else {
      addCategoryOptions.value = [];
      addTagOptions.value = [];
      addKitchenOptions.value = [];
    }
  };

  // 关闭新增菜品弹窗时清空表单和图片列表
  const handleAddModalCancel = () => {
    // 清空表单
    addForm.shopId = undefined;
    addForm.shopFoodCategoryId = undefined;
    addForm.kitchenId = undefined;
    addForm.shopFoodName = '';
    addForm.shopFoodNameShort = '';
    addForm.shopFoodDesc = '';
    addForm.spec = '';
    addForm.price = undefined;
    addForm.bookAdvanceHour = 0;
    addForm.isFoodTicket = 0;
    addForm.description = '';
    addForm.stockQuantity = undefined;
    addForm.limitQuantity = undefined;
    addForm.sort = undefined;
    addForm.cookTime = undefined;
    addForm.outSort = undefined;
    addForm.imageList = [];
    addForm.specList = [];
    addForm.attachmentList = [];
    addForm.cookList = [];
    addForm.selectedTagNames = [];
    resetTranslationForm(addForm.translation);
    // 清空图片列表（包括主图）
    addImageUploadWallRef.value?.clearAll();
    // 清空分类选项和标签选项
    addCategoryOptions.value = [];
    addTagOptions.value = [];
    addKitchenOptions.value = [];
  };

  // 新增弹窗中店铺切换时，联动分类和标签（根据店铺ID重新查询分类和标签）
  const handleAddShopChange = async (value: number | undefined) => {
    addForm.shopId = value as any;
    addForm.shopFoodCategoryId = undefined;
    addForm.kitchenId = undefined;
    addForm.selectedTagNames = [];
    if (!value) {
      addCategoryOptions.value = [];
      addTagOptions.value = [];
      addKitchenOptions.value = [];
      return;
    }
    await loadCategoryListByShop(Number(value), 'add');
    await loadTagListByShop(Number(value), 'add');
    await loadKitchenListByShop(Number(value), 'add');
  };

  const handleAddTagChange = (value: string[]) => {
    addForm.selectedTagNames = value;
  };

  const handleAddTranslationLanguageChange = () => {
    clearFoodTranslationFields(addForm);
  };

  // 图片列表变化处理
  const handleImageListChange = (imageList: ImageItem[]) => {
    // 如果图片列表为空，直接清空附件列表，避免不必要的处理
    if (!imageList || imageList.length === 0) {
      addForm.attachmentList = [];
      return;
    }

    // 同步更新 attachmentList 的 sort 和 status 字段
    addForm.attachmentList = imageList.map((img, index) => {
      // 查找是否已存在对应的附件
      const existingAttachment = addForm.attachmentList.find(
        (att) => att.attachmentUrl === (img.fileInfo?.viewUrl || img.url),
      );

      if (existingAttachment) {
        // 更新已存在的附件的 sort 和 status（从图片项同步）
        return {
          ...existingAttachment,
          sort: index + 1,
          attachmentStatus: ensureStatusValue(
            img.attachmentStatus ?? existingAttachment.attachmentStatus,
          ),
        };
      } else {
        // 创建新的附件项，状态从图片项获取
        return {
          attachmentName: img.name || `图片${index + 1}`,
          attachmentUrl: img.fileInfo?.viewUrl || img.url,
          sort: index + 1,
          attachmentStatus: ensureStatusValue(img.attachmentStatus), // 默认启用
        };
      }
    });
    console.log('图片列表已更新:', imageList);
    console.log('附件列表已同步:', addForm.attachmentList);
  };

  // 规格列表操作
  const addSpecItem = () => {
    addForm.specList.push({
      specName: '',
      translationSpecName: '',
      foodOutCode: '',
      price: 0,
      sourcePrice: undefined,
      specStatus: 0, // 默认启用
      sort: addForm.specList.length + 1,
    });
  };

  const removeSpecItem = (index: number) => {
    addForm.specList.splice(index, 1);
  };

  // 附件列表操作
  const addAttachmentItem = () => {
    addForm.attachmentList.push({
      attachmentName: '',
      attachmentUrl: '',
      sort: addForm.attachmentList.length + 1,
    });
  };

  const removeAttachmentItem = (index: number) => {
    addForm.attachmentList.splice(index, 1);
  };

  // 烹饪列表操作
  const addCookItem = () => {
    addForm.cookList.push({
      cookName: '',
      cookType: 1,
      valueList: [
        {
          value: '',
          translationValue: '',
        },
      ],
      translationCookName: '',
      cookStatus: 0, // 默认启用
      sort: addForm.cookList.length + 1,
    });
  };

  const removeCookItem = (index: number) => {
    addForm.cookList.splice(index, 1);
  };

  const addCookValue = (cookIndex: number) => {
    addForm.cookList[cookIndex].valueList.push({
      value: '',
      translationValue: '',
    });
  };

  const removeCookValue = (cookIndex: number, valueIndex: number) => {
    addForm.cookList[cookIndex].valueList.splice(valueIndex, 1);
  };

  // 编辑表单的规格列表操作
  const addEditSpecItem = () => {
    editForm.specList.push({
      specName: '',
      translationSpecName: '',
      foodOutCode: '',
      price: 0,
      sourcePrice: undefined,
      specStatus: 0, // 默认启用
      sort: editForm.specList.length + 1,
    });
  };

  const removeEditSpecItem = (index: number) => {
    editForm.specList.splice(index, 1);
  };

  // 编辑表单的烹饪列表操作
  const addEditCookItem = () => {
    editForm.cookList.push({
      cookName: '',
      cookType: 1,
      valueList: [
        {
          value: '',
          translationValue: '',
        },
      ],
      translationCookName: '',
      cookStatus: 0, // 默认启用
      sort: editForm.cookList.length + 1,
    });
  };

  const removeEditCookItem = (index: number) => {
    editForm.cookList.splice(index, 1);
  };

  const addEditCookValue = (cookIndex: number) => {
    editForm.cookList[cookIndex].valueList.push({
      value: '',
      translationValue: '',
    });
  };

  const removeEditCookValue = (cookIndex: number, valueIndex: number) => {
    editForm.cookList[cookIndex].valueList.splice(valueIndex, 1);
  };

  const handleAddConfirm = async () => {
    if (
      !addForm.shopId ||
      !addForm.shopFoodCategoryId ||
      !addForm.kitchenId ||
      !addForm.shopFoodName ||
      !addForm.price
    ) {
      message.warning('请完整填写店铺、分类、厨房、名称和价格');
      return;
    }
    // 验证规格列表必填
    if (!addForm.specList || addForm.specList.length === 0) {
      message.warning('请至少添加一个菜品规格');
      return;
    }
    // 验证规格列表中的每个规格是否完整
    const invalidSpec = addForm.specList.find(
      (spec) => !spec.specName || spec.price === undefined || spec.price < 0,
    );
    if (invalidSpec) {
      message.warning('请完整填写所有规格的名称和价格');
      return;
    }
    if (!Number.isInteger(addForm.bookAdvanceHour) || addForm.bookAdvanceHour < 0) {
      message.warning('提前预定小时数必须为非负整数');
      return;
    }
    const invalidSourcePrice = addForm.specList.find(
      (spec) => spec.sourcePrice == null || spec.sourcePrice < spec.price,
    );
    if (invalidSourcePrice) {
      message.warning('请填写规格原价，且原价不能低于售价格');
      return;
    }
    addSubmitting.value = true;
    try {
      // 获取主图的 viewUrl，如果没有主图则使用第一张图片
      const primaryImage = addForm.imageList.find((img) => img.isPrimary) || addForm.imageList[0];
      const imageUrl = primaryImage?.fileInfo?.viewUrl || primaryImage?.url || '';

      // 将选中的标签名称用逗号连接
      const tags = addForm.selectedTagNames.filter((name) => name).join(',');

      // 构建完整的payload
      const payload: any = {
        shopId: addForm.shopId,
        shopFoodCategoryId: addForm.shopFoodCategoryId,
        kitchenId: addForm.kitchenId,
        foodName: addForm.shopFoodName, // 使用店铺菜品名称作为基础菜品名
        shopFoodName: addForm.shopFoodName,
        shopFoodNameShort: trimValue(addForm.shopFoodNameShort),
        shopFoodDesc: addForm.shopFoodDesc || '',
        spec: addForm.spec || '',
        price: addForm.price,
        bookAdvanceHour: addForm.bookAdvanceHour,
        isFoodTicket: addForm.isFoodTicket,
        description: addForm.description || '',
        imageUrl: imageUrl,
        stockQuantity: addForm.stockQuantity,
        limitQuantity: addForm.limitQuantity,
        sort: addForm.sort,
        cookTime: addForm.cookTime,
        outSort: addForm.outSort,
        tags: tags,
        specList: addForm.specList
          .filter((spec) => spec.specName && spec.price !== undefined)
          .map((spec, index) => ({
            // 新增时不传 shopFoodSpecId
            specName: spec.specName,
            foodOutCode: spec.foodOutCode || '',
            price: spec.price,
            sourcePrice: spec.sourcePrice ?? undefined,
            specStatus: ensureStatusValue(spec.specStatus),
            sort: spec.sort ?? index + 1,
          })),
        attachmentList: addForm.imageList
          .map((img, index) => ({
            // 新增时不传 attachmentId
            attachmentName: img.name || `图片${index + 1}`,
            attachmentUrl: img.fileInfo?.viewUrl || img.url,
            sort: index + 1,
            attachmentStatus: ensureStatusValue(img.attachmentStatus),
          }))
          .filter((att) => att.attachmentName && att.attachmentUrl),
        cookList: addForm.cookList
          .filter((cook) => cook.cookName && cook.valueList.length > 0)
          .map((cook, index) => ({
            // 新增时不传 cookId
            cookName: cook.cookName,
            cookType: cook.cookType,
            valueList: cook.valueList.filter((v) => v.value),
            cookStatus: ensureStatusValue(cook.cookStatus),
            sort: cook.sort ?? index + 1,
          })),
      };
      const resp = await initializeFood(payload);
      if (resp.code === 200) {
        message.success('新增菜品成功');
        const createdShopFoodId = Number(resp.result || 0);
        if (createdShopFoodId) {
          try {
            const detailResp = await fetchFoodDetail({ shopFoodId: createdShopFoodId });
            if (detailResp.code === 200 && detailResp.result) {
              hydrateFormIdsFromDetail(addForm, detailResp.result);
            }
            const translationPayloads = buildFoodTranslationPayloads(addForm, createdShopFoodId);
            await submitTranslationPayloads(translationPayloads);
          } catch (translationError) {
            console.error('保存英文翻译失败:', translationError);
            message.warning('菜品保存成功，英文翻译保存失败');
          }
        }
        addModalVisible.value = false;
        // 清空表单和图片列表
        handleAddModalCancel();
        // 重新加载列表
        loadFoodList();
      } else {
        message.error(resp.msg || '新增菜品失败');
      }
    } catch (e) {
      console.error('新增菜品异常:', e);
      message.error('新增菜品异常，请稍后重试');
    } finally {
      addSubmitting.value = false;
    }
  };

  // 重置
  const handleReset = () => {
    queryParams.pageNum = 1;
    queryParams.pageSize = 20;
    queryParams.createtimeBegin = '';
    queryParams.createtimeEnd = '';
    queryParams.data.shopFoodCategoryId = undefined;
    queryParams.data.shopFoodName = '';
    queryParams.data.shopFoodStatus = undefined;
    queryParams.data.searchField = '';
    dateRange.value = null;
    loadFoodList();
  };

  // 分页变化
  const handlePageChange = (page: number) => {
    queryParams.pageNum = page;
    loadFoodList();
  };

  // 每页条数变化
  const handlePageSizeChange = (current: number, size: number) => {
    queryParams.pageNum = 1;
    queryParams.pageSize = size;
    loadFoodList();
  };

  // 根据店铺ID获取店铺名称
  const getShopName = (shopId?: number | string) => {
    if (!shopId) return '-';
    const idNum = Number(shopId);
    const shop = shopList.value.find((s) => s.shopId === idNum);
    return shop?.shopName || '-';
  };

  // 根据分类ID获取分类名称
  const getCategoryName = (categoryId?: number | string) => {
    if (!categoryId) return '-';
    const idNum = Number(categoryId);
    const cat = categoryList.value.find((c) => c.shopFoodCategoryId === idNum);
    return cat?.categoryName || '-';
  };

  const getFoodTagNames = (tags: unknown): string[] => {
    if (typeof tags !== 'string') return [];
    return tags
      .split(',')
      .map((tag) => tag.trim())
      .filter((tag) => tag);
  };

  const getSelectedShop = (shopId?: number) => {
    if (!shopId) return undefined;
    return shopList.value.find((shop) => Number(shop.shopId) === Number(shopId));
  };

  const buildTranslationPayload = (
    shopId: number | undefined,
    language: string,
    type: TranslationPayload['type'],
    entityId: number | undefined,
    entityName: string | undefined,
    translationJson: Record<string, unknown>,
    remark = '',
  ): TranslationPayload | undefined => {
    if (!shopId || !entityId || !entityName) return undefined;
    const shop = getSelectedShop(shopId);
    if (!shop) return undefined;
    return {
      companyId: Number(shop.companyId || 0),
      companyName: shop.companyName || '',
      language,
      type,
      entityId,
      entityName,
      translationJson: JSON.stringify(translationJson),
      remark,
    };
  };

  const submitTranslationPayloads = async (payloads: TranslationPayload[]) => {
    if (payloads.length === 0) return;

    const responses = await Promise.all(
      payloads.map((payload) => {
        if (payload.languageTranslationId) {
          return updateLanguageTranslation({
            languageTranslationId: payload.languageTranslationId,
            translationJson: payload.translationJson,
            remark: payload.remark,
          });
        }
        return insertLanguageTranslation(payload);
      }),
    );
    const failedResponse = responses.find((resp) => resp.code !== 200);
    if (failedResponse) {
      message.warning(failedResponse.msg || '菜品保存成功，部分英文翻译保存失败');
    } else {
      message.success('英文翻译保存成功');
    }
  };

  function parseTranslationJson<T>(translationJson?: string): T | undefined {
    if (!translationJson) return undefined;
    try {
      return JSON.parse(translationJson) as T;
    } catch (error) {
      console.error('解析英文翻译失败:', error);
      return undefined;
    }
  }

  const fetchTranslationRecord = async (
    shopId: number | undefined,
    type: TranslationPayload['type'],
    entityId: number | undefined,
  ): Promise<LanguageTranslationRecord | undefined> => {
    if (!shopId || !entityId) return undefined;
    const shop = getSelectedShop(shopId);
    if (!shop) return undefined;

    const resp = await fetchLanguageTranslationList({
      pageNum: 1,
      pageSize: 20,
      data: {
        companyId: Number(shop.companyId || 0),
        language: editForm.translation.language,
        type,
        status: 0,
        entityId,
      },
    });
    if (resp.code !== 200) return undefined;
    return resp.result.list?.[0] as LanguageTranslationRecord | undefined;
  };

  const loadFoodTranslations = async (shopFoodId: number) => {
    try {
      const foodTranslation = await fetchTranslationRecord(editForm.shopId, 5, shopFoodId);
      const foodTranslationData = parseTranslationJson<FoodTranslationJson>(
        foodTranslation?.translationJson,
      );
      editForm.translation.languageTranslationId = foodTranslation?.languageTranslationId;
      editForm.translation.shopFoodName = foodTranslationData?.shopFoodName || '';
      editForm.translation.shopFoodDesc = foodTranslationData?.shopFoodDesc || '';
      editForm.translation.description = foodTranslationData?.description || '';
      editForm.translation.remark = foodTranslation?.remark || '';

      const specTranslations = await Promise.all(
        editForm.specList.map((spec) =>
          fetchTranslationRecord(editForm.shopId, 6, spec.shopFoodSpecId),
        ),
      );
      specTranslations.forEach((translation, index) => {
        const translationData = parseTranslationJson<SpecTranslationJson>(
          translation?.translationJson,
        );
        editForm.specList[index].languageTranslationId = translation?.languageTranslationId;
        editForm.specList[index].translationSpecName = translationData?.specName || '';
      });

      const cookTranslations = await Promise.all(
        editForm.cookList.map((cook) => fetchTranslationRecord(editForm.shopId, 7, cook.cookId)),
      );
      cookTranslations.forEach((translation, cookIndex) => {
        const translationData = parseTranslationJson<CookTranslationJson>(
          translation?.translationJson,
        );
        const cook = editForm.cookList[cookIndex];
        cook.languageTranslationId = translation?.languageTranslationId;
        cook.translationCookName = translationData?.cookName || '';
        cook.valueList.forEach((valueItem, valueIndex) => {
          valueItem.translationValue = translationData?.cookValue?.[valueIndex]?.value || '';
        });
      });
    } catch (error) {
      console.error('加载菜品英文翻译失败:', error);
    }
  };

  const hydrateFormIdsFromDetail = (form: FoodFormState, detail: any) => {
    const usedSpecIndexes = new Set<number>();
    form.specList.forEach((spec, index) => {
      const detailSpecs = detail?.specList || [];
      const matchedIndex = detailSpecs.findIndex(
        (item: any, itemIndex: number) =>
          !usedSpecIndexes.has(itemIndex) && (item.specName || item.name || '') === spec.specName,
      );
      const detailSpec = detailSpecs[matchedIndex >= 0 ? matchedIndex : index];
      if (detailSpec) {
        spec.shopFoodSpecId = detailSpec.shopFoodSpecId ?? detailSpec.id;
        usedSpecIndexes.add(matchedIndex >= 0 ? matchedIndex : index);
      }
    });

    const usedCookIndexes = new Set<number>();
    form.cookList.forEach((cook, index) => {
      const detailCooks = detail?.cookList || [];
      const matchedIndex = detailCooks.findIndex(
        (item: any, itemIndex: number) =>
          !usedCookIndexes.has(itemIndex) && (item.cookName || '') === cook.cookName,
      );
      const detailCook = detailCooks[matchedIndex >= 0 ? matchedIndex : index];
      if (detailCook) {
        cook.cookId = detailCook.cookId;
        usedCookIndexes.add(matchedIndex >= 0 ? matchedIndex : index);
      }
    });
  };

  const buildFoodTranslationPayloads = (form: FoodFormState, shopFoodId?: number) => {
    const payloads: TranslationPayload[] = [];
    const remark = form.translation.remark || '';

    if (
      hasTranslationValue([
        form.translation.shopFoodName,
        form.translation.shopFoodDesc,
        form.translation.description,
      ])
    ) {
      const foodTranslationJson: Record<string, string> = {};
      if (trimValue(form.translation.shopFoodDesc)) {
        foodTranslationJson.shopFoodDesc = trimValue(form.translation.shopFoodDesc);
      }
      if (trimValue(form.translation.shopFoodName)) {
        foodTranslationJson.shopFoodName = trimValue(form.translation.shopFoodName);
      }
      if (trimValue(form.translation.description)) {
        foodTranslationJson.description = trimValue(form.translation.description);
      }
      const foodPayload = buildTranslationPayload(
        form.shopId,
        form.translation.language,
        5,
        shopFoodId,
        form.shopFoodName,
        foodTranslationJson,
        remark,
      );
      if (foodPayload) {
        foodPayload.languageTranslationId = form.translation.languageTranslationId;
        payloads.push(foodPayload);
      }
    }

    form.specList.forEach((spec) => {
      const translationSpecName = trimValue(spec.translationSpecName);
      if (!translationSpecName) return;
      const specPayload = buildTranslationPayload(
        form.shopId,
        form.translation.language,
        6,
        spec.shopFoodSpecId,
        spec.specName,
        { specName: translationSpecName },
        remark,
      );
      if (specPayload) {
        specPayload.languageTranslationId = spec.languageTranslationId;
        payloads.push(specPayload);
      }
    });

    form.cookList.forEach((cook) => {
      const translationCookName = trimValue(cook.translationCookName);
      const cookValue = cook.valueList
        .map((item) => trimValue(item.translationValue))
        .filter((value) => value)
        .map((value) => ({ value }));
      if (!translationCookName && cookValue.length === 0) return;

      const cookTranslationJson: Record<string, unknown> = {};
      if (translationCookName) {
        cookTranslationJson.cookName = translationCookName;
      }
      if (cookValue.length > 0) {
        cookTranslationJson.cookValue = cookValue;
      }

      const cookPayload = buildTranslationPayload(
        form.shopId,
        form.translation.language,
        7,
        cook.cookId,
        cook.cookName,
        cookTranslationJson,
        remark,
      );
      if (cookPayload) {
        cookPayload.languageTranslationId = cook.languageTranslationId;
        payloads.push(cookPayload);
      }
    });

    return payloads;
  };

  // 打开编辑弹窗
  const openEditModal = async (shopFoodId: number) => {
    editingFoodId.value = shopFoodId;
    editModalVisible.value = true;
    editSubmitting.value = false;
    resetTranslationForm(editForm.translation);

    try {
      // 加载菜品详情
      const response = await fetchFoodDetail({ shopFoodId });
      if (response.code === 200 && response.result) {
        const detail = response.result;
        // 填充编辑表单
        editForm.shopId = detail.shopId;
        editForm.shopFoodCategoryId = detail.shopFoodCategoryId;
        editForm.kitchenId = detail.kitchenId;
        editForm.shopFoodName = detail.shopFoodName || '';
        editForm.shopFoodNameShort = detail.shopFoodNameShort || '';
        editForm.shopFoodDesc = detail.shopFoodDesc || '';
        editForm.spec = detail.spec || '';
        editForm.price = detail.price;
        editForm.bookAdvanceHour = detail.bookAdvanceHour ?? 0;
        editForm.isFoodTicket = detail.isFoodTicket ?? 0;
        editForm.description = detail.description || '';
        editForm.stockQuantity = detail.stockQuantity;
        editForm.limitQuantity = detail.limitQuantity;
        editForm.sort = detail.sort;
        editForm.cookTime = detail.cookTime;
        editForm.outSort = detail.outSort;
        editForm.shopFoodStatus = detail.shopFoodStatus;

        // 加载分类列表和标签列表
        if (editForm.shopId) {
          await loadCategoryListByShop(Number(editForm.shopId), 'edit');
          await loadTagListByShop(Number(editForm.shopId), 'edit');
          await loadKitchenListByShop(Number(editForm.shopId), 'edit');
          clearInvalidEditKitchenValue();
        }

        // 处理标签：将 tags 字符串解析为标签名称数组
        editForm.selectedTagNames = [];
        if (detail.tags) {
          editForm.selectedTagNames = detail.tags
            .split(',')
            .map((name: string) => name.trim())
            .filter((name: string) => name);
        }

        // 处理图片列表
        editForm.imageList = [];
        if (detail.attachmentList && detail.attachmentList.length > 0) {
          // 先排序
          const sortedAttachments = detail.attachmentList.sort(
            (a, b) => (a.sort || 0) - (b.sort || 0),
          );

          // 找到主图（URL 匹配 detail.imageUrl 的，如果没有则第一张）
          let primaryIndex = -1;
          if (detail.imageUrl) {
            primaryIndex = sortedAttachments.findIndex(
              (att) => att.attachmentUrl === detail.imageUrl,
            );
          }
          // 如果没找到匹配的，使用第一张
          if (primaryIndex === -1) {
            primaryIndex = 0;
          }

          editForm.imageList = sortedAttachments.map((att, index) => {
            return {
              uid: `edit-${att.attachmentId || index}-${Date.now()}`,
              name: att.attachmentName || `图片${index + 1}`,
              url: att.attachmentUrl,
              isPrimary: index === primaryIndex, // 只有匹配的或第一张是主图
              attachmentStatus: ensureStatusValue(att.attachmentStatus),
            } as ImageItem;
          });
        } else if (detail.imageUrl) {
          // 如果没有附件列表但有主图，添加主图
          editForm.imageList = [
            {
              uid: `edit-main-${Date.now()}`,
              name: '主图',
              url: detail.imageUrl,
              isPrimary: true,
              attachmentStatus: 0,
            } as ImageItem,
          ];
        }

        // 处理规格列表
        editForm.specList = [];
        if (detail.specList && detail.specList.length > 0) {
          editForm.specList = detail.specList.map((spec: any, index: number) => ({
            shopFoodSpecId: spec.shopFoodSpecId ?? spec.id,
            specName: spec.specName || spec.name || '',
            translationSpecName: '',
            foodOutCode: spec.foodOutCode || '',
            price: spec.price || 0,
            sourcePrice: spec.sourcePrice,
            specStatus: ensureStatusValue(spec.specStatus),
            sort: spec.sort ?? index + 1,
          }));
        }

        // 处理附件列表（从图片列表生成）
        editForm.attachmentList = editForm.imageList.map((img, index) => {
          const existingAtt = detail.attachmentList?.find((att) => att.attachmentUrl === img.url);
          return {
            attachmentId: existingAtt?.attachmentId,
            attachmentName: img.name || `图片${index + 1}`,
            attachmentUrl: img.url,
            sort: index + 1,
            attachmentStatus: ensureStatusValue(img.attachmentStatus),
          };
        });

        // 处理烹饪列表
        editForm.cookList = [];
        if (detail.cookList && detail.cookList.length > 0) {
          editForm.cookList = detail.cookList.map((cook: any, index: number) => ({
            cookId: cook.cookId,
            cookName: cook.cookName || '',
            translationCookName: '',
            cookType: (cook.cookType || 1) as 1 | 2,
            valueList: (cook.valueList || []).map((item: any) => ({
              value: item.value || '',
              translationValue: '',
            })),
            cookStatus: ensureStatusValue(cook.cookStatus),
            sort: cook.sort ?? index + 1,
          }));
        }

        await loadFoodTranslations(shopFoodId);

        // 更新图片上传组件
        nextTick(() => {
          if (editImageUploadWallRef.value) {
            // 图片列表已经设置，组件会自动同步
          }
        });
      } else {
        message.error(response.msg || '加载菜品详情失败');
        editModalVisible.value = false;
      }
    } catch (error) {
      console.error('加载菜品详情失败:', error);
      message.error('加载菜品详情失败，请稍后重试');
      editModalVisible.value = false;
    }
  };

  // 关闭编辑弹窗
  const handleEditModalCancel = () => {
    editingFoodId.value = undefined;
    editForm.shopId = undefined;
    editForm.shopFoodCategoryId = undefined;
    editForm.kitchenId = undefined;
    editForm.shopFoodName = '';
    editForm.shopFoodNameShort = '';
    editForm.shopFoodDesc = '';
    editForm.spec = '';
    editForm.price = undefined;
    editForm.bookAdvanceHour = 0;
    editForm.isFoodTicket = 0;
    editForm.description = '';
    editForm.stockQuantity = undefined;
    editForm.limitQuantity = undefined;
    editForm.sort = undefined;
    editForm.cookTime = undefined;
    editForm.outSort = undefined;
    editForm.shopFoodStatus = undefined;
    editForm.imageList = [];
    editForm.specList = [];
    editForm.attachmentList = [];
    editForm.cookList = [];
    editForm.selectedTagNames = [];
    resetTranslationForm(editForm.translation);
    editImageUploadWallRef.value?.clearAll();
    editCategoryOptions.value = [];
    editTagOptions.value = [];
    editKitchenOptions.value = [];
  };

  // 编辑弹窗中店铺切换
  const handleEditShopChange = async (value: number | undefined) => {
    editForm.shopId = value as any;
    editForm.shopFoodCategoryId = undefined;
    editForm.kitchenId = undefined;
    editForm.selectedTagNames = [];
    if (!value) {
      editCategoryOptions.value = [];
      editTagOptions.value = [];
      editKitchenOptions.value = [];
      return;
    }
    await loadCategoryListByShop(Number(value), 'edit');
    await loadTagListByShop(Number(value), 'edit');
    await loadKitchenListByShop(Number(value), 'edit');
  };

  const handleEditTagChange = (value: string[]) => {
    editForm.selectedTagNames = value;
  };

  const handleEditTranslationLanguageChange = async () => {
    clearFoodTranslationFields(editForm);
    if (editingFoodId.value) {
      await loadFoodTranslations(editingFoodId.value);
    }
  };

  // 编辑图片列表变化处理
  const handleEditImageListChange = (imageList: ImageItem[]) => {
    // 如果图片列表为空，直接清空附件列表，避免不必要的处理
    if (!imageList || imageList.length === 0) {
      editForm.attachmentList = [];
      return;
    }

    editForm.attachmentList = imageList.map((img, index) => {
      const existingAttachment = editForm.attachmentList.find(
        (att) => att.attachmentUrl === (img.fileInfo?.viewUrl || img.url),
      );

      if (existingAttachment) {
        return {
          ...existingAttachment,
          sort: index + 1,
          attachmentStatus: ensureStatusValue(
            img.attachmentStatus ?? existingAttachment.attachmentStatus,
          ),
        };
      } else {
        return {
          attachmentName: img.name || `图片${index + 1}`,
          attachmentUrl: img.fileInfo?.viewUrl || img.url,
          sort: index + 1,
          attachmentStatus: ensureStatusValue(img.attachmentStatus),
        };
      }
    });
  };

  // 编辑确认提交
  const handleEditConfirm = async () => {
    if (
      !editForm.shopId ||
      !editForm.shopFoodCategoryId ||
      !editForm.kitchenId ||
      !editForm.shopFoodName ||
      !editForm.price
    ) {
      message.warning('请完整填写店铺、分类、厨房、名称和价格');
      return;
    }
    if (!editForm.specList || editForm.specList.length === 0) {
      message.warning('请至少添加一个菜品规格');
      return;
    }
    const invalidSpec = editForm.specList.find(
      (spec) => !spec.specName || spec.price === undefined || spec.price < 0,
    );
    if (invalidSpec) {
      message.warning('请完整填写所有规格的名称和价格');
      return;
    }
    if (!Number.isInteger(editForm.bookAdvanceHour) || editForm.bookAdvanceHour < 0) {
      message.warning('提前预定小时数必须为非负整数');
      return;
    }
    const invalidSourcePrice = editForm.specList.find(
      (spec) => spec.sourcePrice == null || spec.sourcePrice < spec.price,
    );
    if (invalidSourcePrice) {
      message.warning('请填写规格原价，且原价不能低于售价');
      return;
    }

    editSubmitting.value = true;
    try {
      const primaryImage = editForm.imageList.find((img) => img.isPrimary) || editForm.imageList[0];
      const imageUrl = primaryImage?.fileInfo?.viewUrl || primaryImage?.url || '';

      // 将选中的标签名称用逗号连接
      const tags = editForm.selectedTagNames.filter((name) => name).join(',');

      const payload: any = {
        shopFoodId: editingFoodId.value,
        shopId: editForm.shopId,
        shopFoodCategoryId: editForm.shopFoodCategoryId,
        kitchenId: editForm.kitchenId,
        foodName: editForm.shopFoodName, // 使用店铺菜品名称作为基础菜品名
        shopFoodName: editForm.shopFoodName,
        shopFoodNameShort: trimValue(editForm.shopFoodNameShort),
        shopFoodDesc: editForm.shopFoodDesc || '',
        shopFoodStatus: editForm.shopFoodStatus,
        spec: editForm.spec || '',
        price: editForm.price,
        bookAdvanceHour: editForm.bookAdvanceHour,
        isFoodTicket: editForm.isFoodTicket,
        description: editForm.description || '',
        imageUrl: imageUrl,
        stockQuantity: editForm.stockQuantity,
        limitQuantity: editForm.limitQuantity,
        sort: editForm.sort,
        cookTime: editForm.cookTime,
        outSort: editForm.outSort,
        tags: tags,
        specList: editForm.specList
          .filter((spec) => spec.specName && spec.price !== undefined)
          .map((spec, index) => ({
            shopFoodSpecId: spec.shopFoodSpecId, // 编辑时需要传ID
            specName: spec.specName,
            foodOutCode: spec.foodOutCode || '',
            price: spec.price,
            sourcePrice: spec.sourcePrice ?? undefined,
            specStatus: ensureStatusValue(spec.specStatus),
            sort: spec.sort ?? index + 1,
          })),
        attachmentList: editForm.imageList
          .map((img, index) => ({
            attachmentId: editForm.attachmentList.find(
              (att) => att.attachmentUrl === (img.fileInfo?.viewUrl || img.url),
            )?.attachmentId, // 编辑时需要传ID
            attachmentName: img.name || `图片${index + 1}`,
            attachmentUrl: img.fileInfo?.viewUrl || img.url,
            sort: index + 1,
            attachmentStatus: ensureStatusValue(img.attachmentStatus),
          }))
          .filter((att) => att.attachmentName && att.attachmentUrl),
        cookList: editForm.cookList
          .filter((cook) => cook.cookName && cook.valueList.length > 0)
          .map((cook, index) => ({
            cookId: cook.cookId, // 编辑时需要传ID
            cookName: cook.cookName,
            cookType: cook.cookType,
            valueList: cook.valueList.filter((v) => v.value),
            cookStatus: ensureStatusValue(cook.cookStatus),
            sort: cook.sort ?? index + 1,
          })),
      };

      const resp = await updateFood(payload);
      if (resp.code === 200) {
        message.success('编辑菜品成功');
        if (editingFoodId.value) {
          try {
            const detailResp = await fetchFoodDetail({ shopFoodId: editingFoodId.value });
            if (detailResp.code === 200 && detailResp.result) {
              hydrateFormIdsFromDetail(editForm, detailResp.result);
            }
            const translationPayloads = buildFoodTranslationPayloads(editForm, editingFoodId.value);
            await submitTranslationPayloads(translationPayloads);
          } catch (translationError) {
            console.error('保存英文翻译失败:', translationError);
            message.warning('菜品保存成功，英文翻译保存失败');
          }
        }
        editModalVisible.value = false;
        handleEditModalCancel();
        loadFoodList();
      } else {
        message.error(resp.msg || '编辑菜品失败');
      }
    } catch (e) {
      console.error('编辑菜品异常:', e);
      message.error('编辑菜品异常，请稍后重试');
    } finally {
      editSubmitting.value = false;
    }
  };

  // 上架/下架菜品
  const handleForbidFood = async (record: any) => {
    const newStatus = record.shopFoodStatus === 0 ? 1 : 0;
    const actionText = newStatus === 1 ? '下架' : '上架';

    try {
      const resp = await forbidFood({
        shopFoodId: record.shopFoodId,
        shopFoodStatus: newStatus,
      });
      if (resp.code === 200) {
        message.success(`${actionText}成功`);
        updateFavoriteFoodStatuses([record.shopFoodId], newStatus);
        loadFoodList();
      } else {
        message.error(resp.msg || `${actionText}失败`);
      }
    } catch (e) {
      console.error(`${actionText}菜品异常:`, e);
      message.error(`${actionText}菜品异常，请稍后重试`);
    }
  };

  // 批量上架/下架菜品，复用单菜品状态接口
  const openBatchFoodStatusConfirm = (
    sourceFoods: BatchFoodRecord[],
    targetStatus: 0 | 1,
    sourceName: string,
  ) => {
    const actionText = targetStatus === 0 ? '上架' : '下架';
    const foodsToUpdate = sourceFoods.filter((food) => food.shopFoodStatus !== targetStatus);
    const skippedCount = sourceFoods.length - foodsToUpdate.length;

    if (foodsToUpdate.length === 0) {
      message.info(`${sourceName}中的菜品均已${actionText}，无需重复操作`);
      return;
    }

    Modal.confirm({
      title: `确认${actionText}${sourceName}？`,
      content: `本次将${actionText} ${foodsToUpdate.length} 个菜品，跳过 ${skippedCount} 个已${actionText}菜品。`,
      okText: `确认${actionText}`,
      cancelText: '取消',
      async onOk() {
        batchTargetStatus.value = targetStatus;
        try {
          const results = await Promise.allSettled(
            foodsToUpdate.map((food) =>
              forbidFood({
                shopFoodId: food.shopFoodId,
                shopFoodStatus: targetStatus,
              }),
            ),
          );
          const successCount = results.filter(
            (result) => result.status === 'fulfilled' && result.value.code === 200,
          ).length;
          const successfulFoodIds = results.flatMap((result, index) =>
            result.status === 'fulfilled' && result.value.code === 200
              ? [foodsToUpdate[index].shopFoodId]
              : [],
          );
          const failedCount = foodsToUpdate.length - successCount;
          const resultText = `成功 ${successCount} 个，失败 ${failedCount} 个，跳过 ${skippedCount} 个`;

          updateFavoriteFoodStatuses(successfulFoodIds, targetStatus);
          if (failedCount === 0) {
            message.success(`批量${actionText}完成：${resultText}`);
          } else {
            message.warning(`批量${actionText}部分失败：${resultText}`);
          }
          await loadFoodList();
        } catch (error) {
          console.error(`批量${actionText}菜品异常:`, error);
          message.error(`批量${actionText}菜品异常，请稍后重试`);
          await loadFoodList();
        } finally {
          batchTargetStatus.value = null;
        }
      },
    });
  };

  // 批量上架/下架当前勾选菜品
  const handleBatchFoodStatus = (targetStatus: 0 | 1) => {
    openBatchFoodStatusConfirm(selectedFoods.value, targetStatus, '所选菜品');
  };

  // 直接上架/下架收藏方案中的菜品
  const handleFavoriteFoodStatus = (favorite: FavoriteSelection, targetStatus: 0 | 1) => {
    openBatchFoodStatusConfirm(favorite.foods, targetStatus, `收藏方案 ${favorite.slot} 中的菜品`);
  };

  // 路由
  const router = useRouter();

  // 返回上一页
  const goHome = () => {
    router.back();
  };

  // 跳转到分类管理
  const goToCategoryManage = () => {
    router.push('/foodCategoryManage');
  };

  // 跳转到标签管理
  const goToLabelManage = () => {
    router.push('/foodLabelManage');
  };

  // 跳转到菜单图生成
  const goToMenuImageGenerate = () => {
    router.push('/menuImageGenerate');
  };

  // 初始化
  onMounted(async () => {
    loadFavoriteSelections();
    await loadShopList();
    await applySavedShopToQuery();
    await loadCategoryList();
    await loadFoodList();
  });

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_config_provider, { locale: _unref(zhCN) }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, { bordered: false }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("button", {
                  class: "page-back-btn",
                  onClick: goHome
                }, [
                  _createVNode(_unref(ArrowLeftOutlined))
                ]),
                _cache[56] || (_cache[56] = _createElementVNode("span", { class: "page-title" }, "菜品管理", -1))
              ]),
              _createVNode(_component_a_form, {
                model: queryParams,
                layout: "inline",
                class: "search-form",
                onSubmit: [
                  handleSearch,
                  _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"]))
                ]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, { label: "店铺" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryParams.data.shopId,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryParams.data.shopId) = $event)),
                        placeholder: "请选择店铺",
                        disabled: "",
                        style: {"width":"200px"},
                        onChange: handleShopChange
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shopList.value, (shop) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: shop.shopId,
                              value: shop.shopId
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(shop.shopName), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "分类" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryParams.data.shopFoodCategoryId,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryParams.data.shopFoodCategoryId) = $event)),
                        placeholder: "请选择分类",
                        "allow-clear": "",
                        style: {"width":"200px"},
                        disabled: !queryParams.data.shopId
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchCategoryOptions.value, (cat) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: cat.shopFoodCategoryId,
                              value: cat.shopFoodCategoryId
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(cat.categoryName), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value", "disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "菜品名称" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryParams.data.shopFoodName,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryParams.data.shopFoodName) = $event)),
                        placeholder: "请输入菜品名称",
                        "allow-clear": "",
                        style: {"width":"200px"}
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "状态" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryParams.data.shopFoodStatus,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryParams.data.shopFoodStatus) = $event)),
                        placeholder: "请选择状态",
                        "allow-clear": "",
                        style: {"width":"120px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select_option, { value: 0 }, {
                            default: _withCtx(() => _cache[57] || (_cache[57] = [
                              _createTextVNode("上架", -1)
                            ])),
                            _: 1,
                            __: [57]
                          }),
                          _createVNode(_component_a_select_option, { value: 1 }, {
                            default: _withCtx(() => _cache[58] || (_cache[58] = [
                              _createTextVNode("下架", -1)
                            ])),
                            _: 1,
                            __: [58]
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "搜索字段" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryParams.data.searchField,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((queryParams.data.searchField) = $event)),
                        placeholder: "支持菜品名称/描述等模糊搜索",
                        "allow-clear": "",
                        style: {"width":"260px"}
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "创建时间" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_range_picker, {
                        value: dateRange.value,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((dateRange).value = $event)),
                        format: "YYYY-MM-DD",
                        style: {"width":"240px"},
                        onChange: handleDateRangeChange
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        "html-type": "submit",
                        loading: loading.value
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(SearchOutlined))
                        ]),
                        default: _withCtx(() => [
                          _cache[59] || (_cache[59] = _createTextVNode(" 查询 ", -1))
                        ]),
                        _: 1,
                        __: [59]
                      }, 8, ["loading"]),
                      _createVNode(_component_a_button, {
                        style: {"margin-left":"8px"},
                        onClick: handleReset
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(ReloadOutlined))
                        ]),
                        default: _withCtx(() => [
                          _cache[60] || (_cache[60] = _createTextVNode(" 重置 ", -1))
                        ]),
                        _: 1,
                        __: [60]
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, [
                  _createVNode(_component_a_button, {
                    type: "default",
                    style: {"margin-right":"8px"},
                    onClick: goToCategoryManage
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_unref(AppstoreOutlined))
                    ]),
                    default: _withCtx(() => [
                      _cache[61] || (_cache[61] = _createTextVNode(" 分类管理 ", -1))
                    ]),
                    _: 1,
                    __: [61]
                  }),
                  _createVNode(_component_a_button, {
                    type: "default",
                    style: {"margin-right":"8px"},
                    onClick: goToLabelManage
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_unref(TagsOutlined))
                    ]),
                    default: _withCtx(() => [
                      _cache[62] || (_cache[62] = _createTextVNode(" 标签管理 ", -1))
                    ]),
                    _: 1,
                    __: [62]
                  }),
                  _createVNode(_component_a_button, {
                    type: "default",
                    onClick: goToMenuImageGenerate
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_unref(PictureOutlined))
                    ]),
                    default: _withCtx(() => [
                      _cache[63] || (_cache[63] = _createTextVNode(" 菜单图生成 ", -1))
                    ]),
                    _: 1,
                    __: [63]
                  })
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_a_button, {
                    style: {"margin-right":"8px"},
                    disabled: selectedFoodIds.value.length === 0 || favoriteSelections.value.length >= 3,
                    onClick: saveCurrentSelection
                  }, {
                    default: _withCtx(() => _cache[64] || (_cache[64] = [
                      _createTextVNode(" 收藏 ", -1)
                    ])),
                    _: 1,
                    __: [64]
                  }, 8, ["disabled"]),
                  _createVNode(_component_a_popover, {
                    placement: "bottomRight",
                    trigger: "click"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        (favoriteSelections.value.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 暂无收藏 "))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(favoriteSelections.value, (favorite) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: favorite.id,
                            class: "favorite-selection-item"
                          }, [
                            _createElementVNode("div", _hoisted_6, " 收藏 " + _toDisplayString(favorite.slot) + "（" + _toDisplayString(favorite.foods.length) + " 个菜品） ", 1),
                            _createElementVNode("div", _hoisted_7, _toDisplayString(getFavoriteFoodNames(favorite)), 1),
                            _createVNode(_component_a_space, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  type: "link",
                                  size: "small",
                                  disabled: batchTargetStatus.value !== null,
                                  onClick: ($event: any) => (handleFavoriteFoodStatus(favorite, 0))
                                }, {
                                  default: _withCtx(() => _cache[65] || (_cache[65] = [
                                    _createTextVNode(" 上架 ", -1)
                                  ])),
                                  _: 2,
                                  __: [65]
                                }, 1032, ["disabled", "onClick"]),
                                _createVNode(_component_a_button, {
                                  type: "link",
                                  danger: "",
                                  size: "small",
                                  disabled: batchTargetStatus.value !== null,
                                  onClick: ($event: any) => (handleFavoriteFoodStatus(favorite, 1))
                                }, {
                                  default: _withCtx(() => _cache[66] || (_cache[66] = [
                                    _createTextVNode(" 下架 ", -1)
                                  ])),
                                  _: 2,
                                  __: [66]
                                }, 1032, ["disabled", "onClick"]),
                                _createVNode(_component_a_popconfirm, {
                                  title: "确认删除该收藏方案？",
                                  "ok-text": "删除",
                                  "cancel-text": "取消",
                                  onConfirm: ($event: any) => (removeFavoriteSelection(favorite.id))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_button, {
                                      type: "link",
                                      danger: "",
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => _cache[67] || (_cache[67] = [
                                        _createTextVNode("删除收藏", -1)
                                      ])),
                                      _: 1,
                                      __: [67]
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["onConfirm"])
                              ]),
                              _: 2
                            }, 1024)
                          ]))
                        }), 128))
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, { style: {"margin-right":"8px"} }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 收藏（" + _toDisplayString(favoriteSelections.value.length) + "/3） ", 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_button, {
                    type: "primary",
                    style: {"margin-right":"8px"},
                    disabled: selectedFoodIds.value.length === 0 || batchTargetStatus.value !== null,
                    loading: batchTargetStatus.value === 0,
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (handleBatchFoodStatus(0)))
                  }, {
                    default: _withCtx(() => _cache[68] || (_cache[68] = [
                      _createTextVNode(" 批量上架 ", -1)
                    ])),
                    _: 1,
                    __: [68]
                  }, 8, ["disabled", "loading"]),
                  _createVNode(_component_a_button, {
                    danger: "",
                    style: {"margin-right":"8px"},
                    disabled: selectedFoodIds.value.length === 0 || batchTargetStatus.value !== null,
                    loading: batchTargetStatus.value === 1,
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (handleBatchFoodStatus(1)))
                  }, {
                    default: _withCtx(() => _cache[69] || (_cache[69] = [
                      _createTextVNode(" 批量下架 ", -1)
                    ])),
                    _: 1,
                    __: [69]
                  }, 8, ["disabled", "loading"]),
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: openAddModal
                  }, {
                    default: _withCtx(() => _cache[70] || (_cache[70] = [
                      _createTextVNode(" 新增菜品 ", -1)
                    ])),
                    _: 1,
                    __: [70]
                  })
                ])
              ]),
              _createVNode(_component_a_table, {
                columns: columns,
                "data-source": tableData.value,
                loading: loading.value,
                pagination: false,
                "row-selection": rowSelection.value,
                "row-key": "shopFoodId",
                scroll: { x: 'max-content' }
              }, {
                bodyCell: _withCtx(({ column, record }) => [
                  (column.key === 'shopFoodStatus')
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        color: record.shopFoodStatus === 0 ? 'green' : 'red'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(record.shopFoodStatus === 0 ? '上架' : '下架'), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"]))
                    : (column.key === 'shopName')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(getShopName(record.shopId)), 1))
                      : (column.key === 'categoryName')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(getCategoryName(record.shopFoodCategoryId)), 1))
                        : (column.key === 'shopFoodNameShort')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(record.shopFoodNameShort || '-'), 1))
                          : (column.key === 'tags')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                (getFoodTagNames(record.tags).length > 0)
                                  ? (_openBlock(), _createBlock(_component_a_space, {
                                      key: 0,
                                      size: [0, 4],
                                      wrap: ""
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getFoodTagNames(record.tags), (tag) => {
                                          return (_openBlock(), _createBlock(_component_a_tag, {
                                            key: tag,
                                            color: "blue"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(tag), 1)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_11, "-"))
                              ], 64))
                            : (column.key === 'isFoodTicket')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                  (record.isFoodTicket !== undefined && record.isFoodTicket !== null)
                                    ? (_openBlock(), _createBlock(_component_a_tag, {
                                        key: 0,
                                        color: record.isFoodTicket === 1 ? 'green' : 'default'
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(record.isFoodTicket === 1 ? '允许' : '不允许'), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["color"]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_12, "-"))
                                ], 64))
                              : (column.key === 'price')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, "¥" + _toDisplayString((record.price || 0).toFixed(2)), 1))
                                : (column.key === 'cookTime')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(record.cookTime ?? '-'), 1))
                                  : (column.key === 'outSort')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(outSortLabels[record.outSort] || '-'), 1))
                                    : (column.key === 'createTime')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(formatDateTime(record.createTime)), 1))
                                      : (column.key === 'action')
                                        ? (_openBlock(), _createBlock(_component_a_space, { key: 10 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_button, {
                                                type: "link",
                                                size: "small",
                                                onClick: ($event: any) => (openEditModal(record.shopFoodId))
                                              }, {
                                                default: _withCtx(() => _cache[71] || (_cache[71] = [
                                                  _createTextVNode(" 编辑 ", -1)
                                                ])),
                                                _: 2,
                                                __: [71]
                                              }, 1032, ["onClick"]),
                                              _createVNode(_component_a_button, {
                                                type: "link",
                                                size: "small",
                                                danger: record.shopFoodStatus === 0,
                                                style: _normalizeStyle(record.shopFoodStatus === 1 ? { color: '#52c41a' } : undefined),
                                                onClick: ($event: any) => (handleForbidFood(record))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(record.shopFoodStatus === 0 ? '下架' : '上架'), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["danger", "style", "onClick"])
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["data-source", "loading", "row-selection"]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_a_pagination, {
                  current: queryParams.pageNum,
                  "onUpdate:current": _cache[9] || (_cache[9] = ($event: any) => ((queryParams.pageNum) = $event)),
                  "page-size": queryParams.pageSize,
                  "onUpdate:pageSize": _cache[10] || (_cache[10] = ($event: any) => ((queryParams.pageSize) = $event)),
                  total: total.value,
                  "show-total": (total) => `共 ${total} 条`,
                  "show-size-changer": true,
                  "page-size-options": ['10', '20', '50', '100'],
                  onChange: handlePageChange,
                  onShowSizeChange: handlePageSizeChange
                }, null, 8, ["current", "page-size", "total", "show-total"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["locale"])
    ]),
    _createVNode(_component_a_modal, {
      open: addModalVisible.value,
      "onUpdate:open": _cache[33] || (_cache[33] = ($event: any) => ((addModalVisible).value = $event)),
      title: "新增菜品",
      "confirm-loading": addSubmitting.value,
      "ok-text": "确认新增",
      "cancel-text": "取消",
      width: 1200,
      "wrap-class-name": "add-food-modal",
      onOk: handleAddConfirm,
      onCancel: handleAddModalCancel
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          layout: "vertical",
          class: "add-food-form compact-food-form"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_a_form_item, {
                label: "店铺",
                required: "",
                class: "form-col"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: addForm.shopId,
                    "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((addForm.shopId) = $event)),
                    placeholder: "请选择店铺",
                    disabled: "",
                    onChange: handleAddShopChange
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shopList.value, (shop) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: shop.shopId,
                          value: shop.shopId
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(shop.shopName), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "分类",
                required: "",
                class: "form-col"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: addForm.shopFoodCategoryId,
                    "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((addForm.shopFoodCategoryId) = $event)),
                    placeholder: "请选择分类",
                    disabled: !addForm.shopId
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addCategoryOptions.value, (cat) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: cat.shopFoodCategoryId,
                          value: cat.shopFoodCategoryId
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(cat.categoryName), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "厨房",
                required: "",
                class: "form-col"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: addForm.kitchenId,
                    "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((addForm.kitchenId) = $event)),
                    placeholder: "请选择厨房",
                    disabled: !addForm.shopId
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addKitchenOptions.value, (kitchen) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: kitchen.shopKitchenId || kitchen.kitchenId,
                          value: kitchen.kitchenId
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(kitchen.kitchenName), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value", "disabled"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_a_form_item, {
                label: "菜品名称",
                required: "",
                class: "form-col"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: addForm.shopFoodName,
                    "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((addForm.shopFoodName) = $event)),
                    placeholder: "请输入菜品名称"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "菜品别名",
                class: "form-col"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: addForm.shopFoodNameShort,
                    "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((addForm.shopFoodNameShort) = $event)),
                    placeholder: "请输入菜品别名（可选）"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "价格",
                required: "",
                class: "form-col"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: addForm.price,
                    "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((addForm.price) = $event)),
                    min: 0,
                    step: 0.01,
                    style: {"width":"100%"},
                    placeholder: "请输入价格"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_a_form_item, {
                label: "菜品描述",
                class: "form-col"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_textarea, {
                    value: addForm.shopFoodDesc,
                    "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((addForm.shopFoodDesc) = $event)),
                    placeholder: "请输入菜品描述",
                    rows: 2,
                    maxlength: 500,
                    "show-count": ""
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "库存数量",
                class: "form-col"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: addForm.stockQuantity,
                    "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((addForm.stockQuantity) = $event)),
                    min: 0,
                    style: {"width":"100%"},
                    placeholder: "请输入库存数量"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "限购数量",
                class: "form-col"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: addForm.limitQuantity,
                    "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((addForm.limitQuantity) = $event)),
                    min: 0,
                    precision: 0,
                    style: {"width":"100%"},
                    placeholder: "请输入限购数量"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "排序",
                class: "form-col"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: addForm.sort,
                    "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((addForm.sort) = $event)),
                    min: 0,
                    style: {"width":"100%"},
                    placeholder: "请输入排序值（越小越靠前）"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_a_form_item, {
                label: "制作时间（分钟）",
                class: "form-col"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: addForm.cookTime,
                    "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((addForm.cookTime) = $event)),
                    min: 0,
                    precision: 0,
                    style: {"width":"100%"},
                    placeholder: "请输入制作时间"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "出菜顺序",
                class: "form-col"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: addForm.outSort,
                    "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((addForm.outSort) = $event)),
                    placeholder: "请选择出菜顺序",
                    "allow-clear": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: 100 }, {
                        default: _withCtx(() => _cache[72] || (_cache[72] = [
                          _createTextVNode("饮料", -1)
                        ])),
                        _: 1,
                        __: [72]
                      }),
                      _createVNode(_component_a_select_option, { value: 70 }, {
                        default: _withCtx(() => _cache[73] || (_cache[73] = [
                          _createTextVNode("冷菜", -1)
                        ])),
                        _: 1,
                        __: [73]
                      }),
                      _createVNode(_component_a_select_option, { value: 50 }, {
                        default: _withCtx(() => _cache[74] || (_cache[74] = [
                          _createTextVNode("热菜", -1)
                        ])),
                        _: 1,
                        __: [74]
                      }),
                      _createVNode(_component_a_select_option, { value: 20 }, {
                        default: _withCtx(() => _cache[75] || (_cache[75] = [
                          _createTextVNode("甜品", -1)
                        ])),
                        _: 1,
                        __: [75]
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "是否允许使用餐券",
                class: "form-col"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_radio_group, {
                    modelValue: addForm.isFoodTicket,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((addForm.isFoodTicket) = $event)),
                    direction: "horizontal"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_radio, { name: 0 }, {
                        default: _withCtx(() => _cache[76] || (_cache[76] = [
                          _createTextVNode("不允许", -1)
                        ])),
                        _: 1,
                        __: [76]
                      }),
                      _createVNode(_component_van_radio, { name: 1 }, {
                        default: _withCtx(() => _cache[77] || (_cache[77] = [
                          _createTextVNode("允许", -1)
                        ])),
                        _: 1,
                        __: [77]
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "提前预定小时数",
                class: "form-col"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: addForm.bookAdvanceHour,
                    "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((addForm.bookAdvanceHour) = $event)),
                    min: 0,
                    precision: 0,
                    style: {"width":"100%"},
                    placeholder: "请输入提前预定小时数"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              false
                ? (_openBlock(), _createBlock(_component_a_form_item, {
                    key: 0,
                    label: "规格",
                    class: "form-col"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: addForm.spec,
                        "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((addForm.spec) = $event)),
                        placeholder: "请输入规格（如：大/中/小）"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_a_form_item, {
              label: "菜品规格列表",
              required: "",
              class: "full-width"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, " 规格翻译语言：" + _toDisplayString(addTranslationLanguageLabel.value) + "（在上方“多语言翻译设置”中切换） ", 1),
                  _cache[80] || (_cache[80] = _createElementVNode("div", { class: "spec-list-header" }, [
                    _createElementVNode("span", { class: "required-header" }, "规格名称"),
                    _createElementVNode("span", null, "翻译名称"),
                    _createElementVNode("span", null, "外部编码"),
                    _createElementVNode("span", { class: "required-header" }, "售价"),
                    _createElementVNode("span", { class: "required-header" }, "原价"),
                    _createElementVNode("span", null, "状态"),
                    _createElementVNode("span", null, "排序"),
                    _createElementVNode("span", null, "操作")
                  ], -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addForm.specList, (spec, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "dynamic-list-item spec-list-row"
                    }, [
                      _createVNode(_component_a_input, {
                        value: spec.specName,
                        "onUpdate:value": ($event: any) => ((spec.specName) = $event),
                        size: "small",
                        placeholder: "规格名称"
                      }, null, 8, ["value", "onUpdate:value"]),
                      _createVNode(_component_a_input, {
                        value: spec.translationSpecName,
                        "onUpdate:value": ($event: any) => ((spec.translationSpecName) = $event),
                        size: "small",
                        placeholder: `翻译规格名称（${addTranslationLanguageLabel.value}）`
                      }, null, 8, ["value", "onUpdate:value", "placeholder"]),
                      _createVNode(_component_a_input, {
                        value: spec.foodOutCode,
                        "onUpdate:value": ($event: any) => ((spec.foodOutCode) = $event),
                        size: "small",
                        placeholder: "外部编码"
                      }, null, 8, ["value", "onUpdate:value"]),
                      _createVNode(_component_a_input_number, {
                        value: spec.price,
                        "onUpdate:value": ($event: any) => ((spec.price) = $event),
                        size: "small",
                        min: 0,
                        step: 0.01,
                        placeholder: "售价",
                        style: {"width":"100%"}
                      }, null, 8, ["value", "onUpdate:value"]),
                      _createVNode(_component_a_input_number, {
                        value: spec.sourcePrice,
                        "onUpdate:value": ($event: any) => ((spec.sourcePrice) = $event),
                        size: "small",
                        min: 0,
                        step: 0.01,
                        placeholder: "原价",
                        style: {"width":"100%"}
                      }, null, 8, ["value", "onUpdate:value"]),
                      _createVNode(_component_a_switch, {
                        checked: spec.specStatus === 0,
                        size: "small",
                        "checked-children": "启用",
                        "un-checked-children": "禁用",
                        onChange: (checked) => (spec.specStatus = checked ? 0 : 1)
                      }, null, 8, ["checked", "onChange"]),
                      _createVNode(_component_a_input_number, {
                        value: spec.sort,
                        "onUpdate:value": ($event: any) => ((spec.sort) = $event),
                        size: "small",
                        min: 0,
                        placeholder: "排序",
                        style: {"width":"100%"}
                      }, null, 8, ["value", "onUpdate:value"]),
                      _createVNode(_component_a_button, {
                        type: "text",
                        danger: "",
                        size: "small",
                        icon: h(_unref(DeleteOutlined)),
                        onClick: ($event: any) => (removeSpecItem(index))
                      }, {
                        default: _withCtx(() => _cache[78] || (_cache[78] = [
                          _createTextVNode(" 删除 ", -1)
                        ])),
                        _: 2,
                        __: [78]
                      }, 1032, ["icon", "onClick"])
                    ]))
                  }), 128)),
                  _createVNode(_component_a_button, {
                    type: "dashed",
                    icon: h(_unref(PlusOutlined)),
                    style: {"width":"100%"},
                    onClick: addSpecItem
                  }, {
                    default: _withCtx(() => _cache[79] || (_cache[79] = [
                      _createTextVNode(" 添加规格 ", -1)
                    ])),
                    _: 1,
                    __: [79]
                  }, 8, ["icon"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "烹饪列表",
              class: "full-width"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, " 烹饪翻译语言：" + _toDisplayString(addTranslationLanguageLabel.value) + "（在上方“多语言翻译设置”中切换） ", 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addForm.cookList, (cook, cookIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: cookIndex,
                      class: "dynamic-list-item cook-item"
                    }, [
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_a_input, {
                          value: cook.cookName,
                          "onUpdate:value": ($event: any) => ((cook.cookName) = $event),
                          placeholder: "烹饪名称（如：做法）",
                          style: {"width":"200px","margin-right":"8px"}
                        }, null, 8, ["value", "onUpdate:value"]),
                        _createVNode(_component_a_input, {
                          value: cook.translationCookName,
                          "onUpdate:value": ($event: any) => ((cook.translationCookName) = $event),
                          placeholder: `翻译烹饪名称（${addTranslationLanguageLabel.value}）`,
                          style: {"width":"180px","margin-right":"8px"}
                        }, null, 8, ["value", "onUpdate:value", "placeholder"]),
                        _createVNode(_component_a_select, {
                          value: cook.cookType,
                          "onUpdate:value": ($event: any) => ((cook.cookType) = $event),
                          placeholder: "类型",
                          style: {"width":"120px","margin-right":"8px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select_option, { value: 1 }, {
                              default: _withCtx(() => _cache[81] || (_cache[81] = [
                                _createTextVNode("多选", -1)
                              ])),
                              _: 1,
                              __: [81]
                            }),
                            _createVNode(_component_a_select_option, { value: 2 }, {
                              default: _withCtx(() => _cache[82] || (_cache[82] = [
                                _createTextVNode("单选", -1)
                              ])),
                              _: 1,
                              __: [82]
                            })
                          ]),
                          _: 2
                        }, 1032, ["value", "onUpdate:value"]),
                        _createVNode(_component_a_switch, {
                          checked: cook.cookStatus === 0,
                          "checked-children": "启用",
                          "un-checked-children": "禁用",
                          style: {"margin-right":"8px"},
                          onChange: (checked) => (cook.cookStatus = checked ? 0 : 1)
                        }, null, 8, ["checked", "onChange"]),
                        _createVNode(_component_a_input_number, {
                          value: cook.sort,
                          "onUpdate:value": ($event: any) => ((cook.sort) = $event),
                          min: 0,
                          placeholder: "排序",
                          style: {"width":"100px","margin-right":"8px"}
                        }, null, 8, ["value", "onUpdate:value"]),
                        _createVNode(_component_a_button, {
                          type: "text",
                          danger: "",
                          icon: h(_unref(DeleteOutlined)),
                          onClick: ($event: any) => (removeCookItem(cookIndex))
                        }, {
                          default: _withCtx(() => _cache[83] || (_cache[83] = [
                            _createTextVNode(" 删除 ", -1)
                          ])),
                          _: 2,
                          __: [83]
                        }, 1032, ["icon", "onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cook.valueList, (value, valueIndex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: valueIndex,
                            class: "value-item"
                          }, [
                            _createVNode(_component_a_input, {
                              value: value.value,
                              "onUpdate:value": ($event: any) => ((value.value) = $event),
                              placeholder: "枚举值（如：常规）",
                              style: {"width":"200px","margin-right":"8px"}
                            }, null, 8, ["value", "onUpdate:value"]),
                            _createVNode(_component_a_input, {
                              value: value.translationValue,
                              "onUpdate:value": ($event: any) => ((value.translationValue) = $event),
                              placeholder: `翻译枚举值（${addTranslationLanguageLabel.value}）`,
                              style: {"width":"180px","margin-right":"8px"}
                            }, null, 8, ["value", "onUpdate:value", "placeholder"]),
                            _createVNode(_component_a_button, {
                              type: "text",
                              danger: "",
                              size: "small",
                              icon: h(_unref(MinusOutlined)),
                              onClick: ($event: any) => (removeCookValue(cookIndex, valueIndex))
                            }, {
                              default: _withCtx(() => _cache[84] || (_cache[84] = [
                                _createTextVNode(" 删除 ", -1)
                              ])),
                              _: 2,
                              __: [84]
                            }, 1032, ["icon", "onClick"])
                          ]))
                        }), 128)),
                        _createVNode(_component_a_button, {
                          type: "dashed",
                          size: "small",
                          icon: h(_unref(PlusOutlined)),
                          style: {"width":"200px"},
                          onClick: ($event: any) => (addCookValue(cookIndex))
                        }, {
                          default: _withCtx(() => _cache[85] || (_cache[85] = [
                            _createTextVNode(" 添加枚举值 ", -1)
                          ])),
                          _: 2,
                          __: [85]
                        }, 1032, ["icon", "onClick"])
                      ])
                    ]))
                  }), 128)),
                  _createVNode(_component_a_button, {
                    type: "dashed",
                    icon: h(_unref(PlusOutlined)),
                    style: {"width":"100%"},
                    onClick: addCookItem
                  }, {
                    default: _withCtx(() => _cache[86] || (_cache[86] = [
                      _createTextVNode(" 添加烹饪项 ", -1)
                    ])),
                    _: 1,
                    __: [86]
                  }, 8, ["icon"])
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_a_form_item, {
                label: "详细描述",
                class: "full-width"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_textarea, {
                    value: addForm.description,
                    "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((addForm.description) = $event)),
                    placeholder: "请输入详细描述",
                    rows: 3,
                    maxlength: 1000,
                    "show-count": ""
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_a_form_item, {
                label: "菜品标签",
                class: "full-width"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: addForm.selectedTagNames,
                    "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((addForm.selectedTagNames) = $event)),
                    mode: "multiple",
                    placeholder: "请选择标签（可多选）",
                    disabled: !addForm.shopId,
                    style: {"width":"100%"},
                    onChange: handleAddTagChange
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addTagOptions.value, (tag) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: tag.shopFoodTagId,
                          value: tag.tagName
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tag.tagName), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value", "disabled"])
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_a_collapse, {
              ghost: "",
              class: "translation-collapse"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_collapse_panel, {
                  key: "translation",
                  header: "多语言翻译设置"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(_component_a_form_item, {
                        label: "翻译语言",
                        class: "form-col"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: addForm.translation.language,
                            "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((addForm.translation.language) = $event)),
                            placeholder: "请选择翻译语言",
                            onChange: handleAddTranslationLanguageChange
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(translationLanguageOptions, (language) => {
                                return _createVNode(_component_a_select_option, {
                                  key: language.value,
                                  value: language.value
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(language.label), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"])
                              }), 64))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_a_form_item, {
                        label: "菜品翻译名称",
                        class: "form-col"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: addForm.translation.shopFoodName,
                            "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((addForm.translation.shopFoodName) = $event)),
                            placeholder: "请输入菜品翻译名称"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_a_form_item, {
                        label: "菜品翻译描述",
                        class: "form-col"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_textarea, {
                            value: addForm.translation.shopFoodDesc,
                            "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((addForm.translation.shopFoodDesc) = $event)),
                            placeholder: "请输入菜品翻译描述",
                            rows: 3
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, {
                        label: "翻译详细描述",
                        class: "form-col"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_textarea, {
                            value: addForm.translation.description,
                            "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((addForm.translation.description) = $event)),
                            placeholder: "请输入翻译详细描述",
                            rows: 3
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "菜品图片",
              class: "full-width"
            }, {
              default: _withCtx(() => [
                _createVNode(ImageUploadWall, {
                  ref_key: "addImageUploadWallRef",
                  ref: addImageUploadWallRef,
                  modelValue: addForm.imageList,
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((addForm.imageList) = $event)),
                  "max-count": 10,
                  "compress-before-upload": "",
                  onChange: handleImageListChange
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            false
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 0,
                  label: "附件列表",
                  class: "full-width"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_33, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addForm.attachmentList, (attachment, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "dynamic-list-item"
                        }, [
                          _createVNode(_component_a_input, {
                            value: attachment.attachmentName,
                            "onUpdate:value": ($event: any) => ((attachment.attachmentName) = $event),
                            placeholder: "附件名称",
                            style: {"width":"200px","margin-right":"8px"}
                          }, null, 8, ["value", "onUpdate:value"]),
                          _createVNode(_component_a_input, {
                            value: attachment.attachmentUrl,
                            "onUpdate:value": ($event: any) => ((attachment.attachmentUrl) = $event),
                            placeholder: "附件URL",
                            style: {"width":"300px","margin-right":"8px"}
                          }, null, 8, ["value", "onUpdate:value"]),
                          _createVNode(_component_a_input_number, {
                            value: attachment.sort,
                            "onUpdate:value": ($event: any) => ((attachment.sort) = $event),
                            min: 1,
                            placeholder: "排序",
                            style: {"width":"100px","margin-right":"8px"}
                          }, null, 8, ["value", "onUpdate:value"]),
                          _createVNode(_component_a_button, {
                            type: "text",
                            danger: "",
                            icon: h(_unref(DeleteOutlined)),
                            onClick: ($event: any) => (removeAttachmentItem(index))
                          }, {
                            default: _withCtx(() => _cache[87] || (_cache[87] = [
                              _createTextVNode(" 删除 ", -1)
                            ])),
                            _: 2,
                            __: [87]
                          }, 1032, ["icon", "onClick"])
                        ]))
                      }), 128)),
                      _createVNode(_component_a_button, {
                        type: "dashed",
                        icon: h(_unref(PlusOutlined)),
                        style: {"width":"100%"},
                        onClick: addAttachmentItem
                      }, {
                        default: _withCtx(() => _cache[88] || (_cache[88] = [
                          _createTextVNode(" 添加附件 ", -1)
                        ])),
                        _: 1,
                        __: [88]
                      }, 8, ["icon"])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open", "confirm-loading"]),
    _createVNode(_component_a_modal, {
      open: editModalVisible.value,
      "onUpdate:open": _cache[55] || (_cache[55] = ($event: any) => ((editModalVisible).value = $event)),
      title: "编辑菜品",
      "confirm-loading": editSubmitting.value,
      "ok-text": "确认编辑",
      "cancel-text": "取消",
      width: 1200,
      "wrap-class-name": "add-food-modal",
      onOk: handleEditConfirm,
      onCancel: handleEditModalCancel
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          layout: "vertical",
          class: "add-food-form compact-food-form"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_a_form_item, {
                label: "店铺",
                required: "",
                class: "form-col"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: editForm.shopId,
                    "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((editForm.shopId) = $event)),
                    placeholder: "请选择店铺",
                    disabled: "",
                    onChange: handleEditShopChange
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shopList.value, (shop) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: shop.shopId,
                          value: shop.shopId
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(shop.shopName), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "分类",
                required: "",
                class: "form-col"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: editForm.shopFoodCategoryId,
                    "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((editForm.shopFoodCategoryId) = $event)),
                    placeholder: "请选择分类",
                    disabled: !editForm.shopId
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editCategoryOptions.value, (cat) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: cat.shopFoodCategoryId,
                          value: cat.shopFoodCategoryId
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(cat.categoryName), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "厨房",
                required: "",
                class: "form-col"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: editForm.kitchenId,
                    "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((editForm.kitchenId) = $event)),
                    placeholder: "请选择厨房",
                    disabled: !editForm.shopId
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editKitchenOptions.value, (kitchen) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: kitchen.shopKitchenId || kitchen.kitchenId,
                          value: kitchen.kitchenId
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(kitchen.kitchenName), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value", "disabled"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_a_form_item, {
                label: "菜品名称",
                required: "",
                class: "form-col"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: editForm.shopFoodName,
                    "onUpdate:value": _cache[37] || (_cache[37] = ($event: any) => ((editForm.shopFoodName) = $event)),
                    placeholder: "请输入菜品名称"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "菜品别名",
                class: "form-col"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: editForm.shopFoodNameShort,
                    "onUpdate:value": _cache[38] || (_cache[38] = ($event: any) => ((editForm.shopFoodNameShort) = $event)),
                    placeholder: "请输入菜品别名（可选）"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "价格",
                required: "",
                class: "form-col"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: editForm.price,
                    "onUpdate:value": _cache[39] || (_cache[39] = ($event: any) => ((editForm.price) = $event)),
                    min: 0,
                    step: 0.01,
                    style: {"width":"100%"},
                    placeholder: "请输入价格"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createVNode(_component_a_form_item, {
                label: "菜品描述",
                class: "form-col"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_textarea, {
                    value: editForm.shopFoodDesc,
                    "onUpdate:value": _cache[40] || (_cache[40] = ($event: any) => ((editForm.shopFoodDesc) = $event)),
                    placeholder: "请输入菜品描述",
                    rows: 2,
                    maxlength: 500,
                    "show-count": ""
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "库存数量",
                class: "form-col"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: editForm.stockQuantity,
                    "onUpdate:value": _cache[41] || (_cache[41] = ($event: any) => ((editForm.stockQuantity) = $event)),
                    min: 0,
                    style: {"width":"100%"},
                    placeholder: "请输入库存数量"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "限购数量",
                class: "form-col"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: editForm.limitQuantity,
                    "onUpdate:value": _cache[42] || (_cache[42] = ($event: any) => ((editForm.limitQuantity) = $event)),
                    min: 0,
                    precision: 0,
                    style: {"width":"100%"},
                    placeholder: "请输入限购数量"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "排序",
                class: "form-col"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: editForm.sort,
                    "onUpdate:value": _cache[43] || (_cache[43] = ($event: any) => ((editForm.sort) = $event)),
                    min: 0,
                    style: {"width":"100%"},
                    placeholder: "请输入排序值（越小越靠前）"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createVNode(_component_a_form_item, {
                label: "制作时间（分钟）",
                class: "form-col"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: editForm.cookTime,
                    "onUpdate:value": _cache[44] || (_cache[44] = ($event: any) => ((editForm.cookTime) = $event)),
                    min: 0,
                    precision: 0,
                    style: {"width":"100%"},
                    placeholder: "请输入制作时间"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "出菜顺序",
                class: "form-col"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: editForm.outSort,
                    "onUpdate:value": _cache[45] || (_cache[45] = ($event: any) => ((editForm.outSort) = $event)),
                    placeholder: "请选择出菜顺序",
                    "allow-clear": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: 100 }, {
                        default: _withCtx(() => _cache[89] || (_cache[89] = [
                          _createTextVNode("饮料", -1)
                        ])),
                        _: 1,
                        __: [89]
                      }),
                      _createVNode(_component_a_select_option, { value: 70 }, {
                        default: _withCtx(() => _cache[90] || (_cache[90] = [
                          _createTextVNode("冷菜", -1)
                        ])),
                        _: 1,
                        __: [90]
                      }),
                      _createVNode(_component_a_select_option, { value: 50 }, {
                        default: _withCtx(() => _cache[91] || (_cache[91] = [
                          _createTextVNode("热菜", -1)
                        ])),
                        _: 1,
                        __: [91]
                      }),
                      _createVNode(_component_a_select_option, { value: 20 }, {
                        default: _withCtx(() => _cache[92] || (_cache[92] = [
                          _createTextVNode("甜品", -1)
                        ])),
                        _: 1,
                        __: [92]
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "是否允许使用餐券",
                class: "form-col"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_radio_group, {
                    modelValue: editForm.isFoodTicket,
                    "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((editForm.isFoodTicket) = $event)),
                    direction: "horizontal"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_radio, { name: 0 }, {
                        default: _withCtx(() => _cache[93] || (_cache[93] = [
                          _createTextVNode("不允许", -1)
                        ])),
                        _: 1,
                        __: [93]
                      }),
                      _createVNode(_component_van_radio, { name: 1 }, {
                        default: _withCtx(() => _cache[94] || (_cache[94] = [
                          _createTextVNode("允许", -1)
                        ])),
                        _: 1,
                        __: [94]
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "提前预定小时数",
                class: "form-col"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: editForm.bookAdvanceHour,
                    "onUpdate:value": _cache[47] || (_cache[47] = ($event: any) => ((editForm.bookAdvanceHour) = $event)),
                    min: 0,
                    precision: 0,
                    style: {"width":"100%"},
                    placeholder: "请输入提前预定小时数"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_a_form_item, {
              label: "菜品规格列表",
              required: "",
              class: "full-width"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, " 规格翻译语言：" + _toDisplayString(editTranslationLanguageLabel.value) + "（在上方“多语言翻译设置”中切换） ", 1),
                  _cache[97] || (_cache[97] = _createElementVNode("div", { class: "spec-list-header" }, [
                    _createElementVNode("span", { class: "required-header" }, "规格名称"),
                    _createElementVNode("span", null, "翻译名称"),
                    _createElementVNode("span", null, "外部编码"),
                    _createElementVNode("span", { class: "required-header" }, "售价"),
                    _createElementVNode("span", { class: "required-header" }, "原价"),
                    _createElementVNode("span", null, "状态"),
                    _createElementVNode("span", null, "排序"),
                    _createElementVNode("span", null, "操作")
                  ], -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editForm.specList, (spec, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "dynamic-list-item spec-list-row"
                    }, [
                      _createVNode(_component_a_input, {
                        value: spec.specName,
                        "onUpdate:value": ($event: any) => ((spec.specName) = $event),
                        size: "small",
                        placeholder: "规格名称"
                      }, null, 8, ["value", "onUpdate:value"]),
                      _createVNode(_component_a_input, {
                        value: spec.translationSpecName,
                        "onUpdate:value": ($event: any) => ((spec.translationSpecName) = $event),
                        size: "small",
                        placeholder: `翻译规格名称（${editTranslationLanguageLabel.value}）`
                      }, null, 8, ["value", "onUpdate:value", "placeholder"]),
                      _createVNode(_component_a_input, {
                        value: spec.foodOutCode,
                        "onUpdate:value": ($event: any) => ((spec.foodOutCode) = $event),
                        size: "small",
                        placeholder: "外部编码"
                      }, null, 8, ["value", "onUpdate:value"]),
                      _createVNode(_component_a_input_number, {
                        value: spec.price,
                        "onUpdate:value": ($event: any) => ((spec.price) = $event),
                        size: "small",
                        min: 0,
                        step: 0.01,
                        placeholder: "售价",
                        style: {"width":"100%"}
                      }, null, 8, ["value", "onUpdate:value"]),
                      _createVNode(_component_a_input_number, {
                        value: spec.sourcePrice,
                        "onUpdate:value": ($event: any) => ((spec.sourcePrice) = $event),
                        size: "small",
                        min: 0,
                        step: 0.01,
                        placeholder: "原价",
                        style: {"width":"100%"}
                      }, null, 8, ["value", "onUpdate:value"]),
                      _createVNode(_component_a_switch, {
                        checked: spec.specStatus === 0,
                        size: "small",
                        "checked-children": "启用",
                        "un-checked-children": "禁用",
                        onChange: (checked) => (spec.specStatus = checked ? 0 : 1)
                      }, null, 8, ["checked", "onChange"]),
                      _createVNode(_component_a_input_number, {
                        value: spec.sort,
                        "onUpdate:value": ($event: any) => ((spec.sort) = $event),
                        size: "small",
                        min: 0,
                        placeholder: "排序",
                        style: {"width":"100%"}
                      }, null, 8, ["value", "onUpdate:value"]),
                      _createVNode(_component_a_button, {
                        type: "text",
                        danger: "",
                        size: "small",
                        icon: h(_unref(DeleteOutlined)),
                        onClick: ($event: any) => (removeEditSpecItem(index))
                      }, {
                        default: _withCtx(() => _cache[95] || (_cache[95] = [
                          _createTextVNode(" 删除 ", -1)
                        ])),
                        _: 2,
                        __: [95]
                      }, 1032, ["icon", "onClick"])
                    ]))
                  }), 128)),
                  _createVNode(_component_a_button, {
                    type: "dashed",
                    icon: h(_unref(PlusOutlined)),
                    style: {"width":"100%"},
                    onClick: addEditSpecItem
                  }, {
                    default: _withCtx(() => _cache[96] || (_cache[96] = [
                      _createTextVNode(" 添加规格 ", -1)
                    ])),
                    _: 1,
                    __: [96]
                  }, 8, ["icon"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "烹饪列表",
              class: "full-width"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, " 烹饪翻译语言：" + _toDisplayString(editTranslationLanguageLabel.value) + "（在上方“多语言翻译设置”中切换） ", 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editForm.cookList, (cook, cookIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: cookIndex,
                      class: "dynamic-list-item cook-item"
                    }, [
                      _createElementVNode("div", _hoisted_42, [
                        _createVNode(_component_a_input, {
                          value: cook.cookName,
                          "onUpdate:value": ($event: any) => ((cook.cookName) = $event),
                          placeholder: "烹饪名称（如：做法）",
                          style: {"width":"200px","margin-right":"8px"}
                        }, null, 8, ["value", "onUpdate:value"]),
                        _createVNode(_component_a_input, {
                          value: cook.translationCookName,
                          "onUpdate:value": ($event: any) => ((cook.translationCookName) = $event),
                          placeholder: `翻译烹饪名称（${editTranslationLanguageLabel.value}）`,
                          style: {"width":"180px","margin-right":"8px"}
                        }, null, 8, ["value", "onUpdate:value", "placeholder"]),
                        _createVNode(_component_a_select, {
                          value: cook.cookType,
                          "onUpdate:value": ($event: any) => ((cook.cookType) = $event),
                          placeholder: "类型",
                          style: {"width":"120px","margin-right":"8px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select_option, { value: 1 }, {
                              default: _withCtx(() => _cache[98] || (_cache[98] = [
                                _createTextVNode("多选", -1)
                              ])),
                              _: 1,
                              __: [98]
                            }),
                            _createVNode(_component_a_select_option, { value: 2 }, {
                              default: _withCtx(() => _cache[99] || (_cache[99] = [
                                _createTextVNode("单选", -1)
                              ])),
                              _: 1,
                              __: [99]
                            })
                          ]),
                          _: 2
                        }, 1032, ["value", "onUpdate:value"]),
                        _createVNode(_component_a_switch, {
                          checked: cook.cookStatus === 0,
                          "checked-children": "启用",
                          "un-checked-children": "禁用",
                          style: {"margin-right":"8px"},
                          onChange: (checked) => (cook.cookStatus = checked ? 0 : 1)
                        }, null, 8, ["checked", "onChange"]),
                        _createVNode(_component_a_input_number, {
                          value: cook.sort,
                          "onUpdate:value": ($event: any) => ((cook.sort) = $event),
                          min: 0,
                          placeholder: "排序",
                          style: {"width":"100px","margin-right":"8px"}
                        }, null, 8, ["value", "onUpdate:value"]),
                        _createVNode(_component_a_button, {
                          type: "text",
                          danger: "",
                          icon: h(_unref(DeleteOutlined)),
                          onClick: ($event: any) => (removeEditCookItem(cookIndex))
                        }, {
                          default: _withCtx(() => _cache[100] || (_cache[100] = [
                            _createTextVNode(" 删除 ", -1)
                          ])),
                          _: 2,
                          __: [100]
                        }, 1032, ["icon", "onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cook.valueList, (value, valueIndex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: valueIndex,
                            class: "value-item"
                          }, [
                            _createVNode(_component_a_input, {
                              value: value.value,
                              "onUpdate:value": ($event: any) => ((value.value) = $event),
                              placeholder: "枚举值（如：常规）",
                              style: {"width":"200px","margin-right":"8px"}
                            }, null, 8, ["value", "onUpdate:value"]),
                            _createVNode(_component_a_input, {
                              value: value.translationValue,
                              "onUpdate:value": ($event: any) => ((value.translationValue) = $event),
                              placeholder: `翻译枚举值（${editTranslationLanguageLabel.value}）`,
                              style: {"width":"180px","margin-right":"8px"}
                            }, null, 8, ["value", "onUpdate:value", "placeholder"]),
                            _createVNode(_component_a_button, {
                              type: "text",
                              danger: "",
                              size: "small",
                              icon: h(_unref(MinusOutlined)),
                              onClick: ($event: any) => (removeEditCookValue(cookIndex, valueIndex))
                            }, {
                              default: _withCtx(() => _cache[101] || (_cache[101] = [
                                _createTextVNode(" 删除 ", -1)
                              ])),
                              _: 2,
                              __: [101]
                            }, 1032, ["icon", "onClick"])
                          ]))
                        }), 128)),
                        _createVNode(_component_a_button, {
                          type: "dashed",
                          size: "small",
                          icon: h(_unref(PlusOutlined)),
                          style: {"width":"200px"},
                          onClick: ($event: any) => (addEditCookValue(cookIndex))
                        }, {
                          default: _withCtx(() => _cache[102] || (_cache[102] = [
                            _createTextVNode(" 添加枚举值 ", -1)
                          ])),
                          _: 2,
                          __: [102]
                        }, 1032, ["icon", "onClick"])
                      ])
                    ]))
                  }), 128)),
                  _createVNode(_component_a_button, {
                    type: "dashed",
                    icon: h(_unref(PlusOutlined)),
                    style: {"width":"100%"},
                    onClick: addEditCookItem
                  }, {
                    default: _withCtx(() => _cache[103] || (_cache[103] = [
                      _createTextVNode(" 添加烹饪项 ", -1)
                    ])),
                    _: 1,
                    __: [103]
                  }, 8, ["icon"])
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_44, [
              _createVNode(_component_a_form_item, {
                label: "详细描述",
                class: "full-width"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_textarea, {
                    value: editForm.description,
                    "onUpdate:value": _cache[48] || (_cache[48] = ($event: any) => ((editForm.description) = $event)),
                    placeholder: "请输入详细描述",
                    rows: 3,
                    maxlength: 1000,
                    "show-count": ""
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createVNode(_component_a_form_item, {
                label: "菜品标签",
                class: "full-width"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: editForm.selectedTagNames,
                    "onUpdate:value": _cache[49] || (_cache[49] = ($event: any) => ((editForm.selectedTagNames) = $event)),
                    mode: "multiple",
                    placeholder: "请选择标签（可多选）",
                    disabled: !editForm.shopId,
                    style: {"width":"100%"},
                    onChange: handleEditTagChange
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editTagOptions.value, (tag) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: tag.shopFoodTagId,
                          value: tag.tagName
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tag.tagName), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value", "disabled"])
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_a_collapse, {
              ghost: "",
              class: "translation-collapse"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_collapse_panel, {
                  key: "translation",
                  header: "多语言翻译设置"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_46, [
                      _createVNode(_component_a_form_item, {
                        label: "翻译语言",
                        class: "form-col"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: editForm.translation.language,
                            "onUpdate:value": _cache[50] || (_cache[50] = ($event: any) => ((editForm.translation.language) = $event)),
                            placeholder: "请选择翻译语言",
                            onChange: handleEditTranslationLanguageChange
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(translationLanguageOptions, (language) => {
                                return _createVNode(_component_a_select_option, {
                                  key: language.value,
                                  value: language.value
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(language.label), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"])
                              }), 64))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createVNode(_component_a_form_item, {
                        label: "菜品翻译名称",
                        class: "form-col"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: editForm.translation.shopFoodName,
                            "onUpdate:value": _cache[51] || (_cache[51] = ($event: any) => ((editForm.translation.shopFoodName) = $event)),
                            placeholder: "请输入菜品翻译名称"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                      _createVNode(_component_a_form_item, {
                        label: "菜品翻译描述",
                        class: "form-col"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_textarea, {
                            value: editForm.translation.shopFoodDesc,
                            "onUpdate:value": _cache[52] || (_cache[52] = ($event: any) => ((editForm.translation.shopFoodDesc) = $event)),
                            placeholder: "请输入菜品翻译描述",
                            rows: 3
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, {
                        label: "翻译详细描述",
                        class: "form-col"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_textarea, {
                            value: editForm.translation.description,
                            "onUpdate:value": _cache[53] || (_cache[53] = ($event: any) => ((editForm.translation.description) = $event)),
                            placeholder: "请输入翻译详细描述",
                            rows: 3
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "菜品图片",
              class: "full-width"
            }, {
              default: _withCtx(() => [
                _createVNode(ImageUploadWall, {
                  ref_key: "editImageUploadWallRef",
                  ref: editImageUploadWallRef,
                  modelValue: editForm.imageList,
                  "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((editForm.imageList) = $event)),
                  "max-count": 10,
                  "compress-before-upload": "",
                  onChange: handleEditImageListChange
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open", "confirm-loading"])
  ], 64))
}
}

})